<template>
  <div>
    <vs-popup id="memberView" title="환자 등록 및 수정" :active.sync="openPopup" @close="releaseChartNoReservation">
      <form @submit.prevent>
        <div class="vx-row mb-3">
          <vs-button type="line" :class="activeMenu2(1)" @click="popTabClick(1)">환자관리</vs-button>
          <vs-button type="line" :class="activeMenu2(2)" @click="popTabClick(2)" v-show="tab_sum & 1024">상담내역</vs-button>
        </div>
        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-input type="text" v-validate="'required'" class="w-full" name="chartNo" v-model="chartNo" label="차트번호" placeholder="ex) 123" @input="onChartNoInput" />
                <!-- 중복확인 버튼 (필요 시 활성화)
                <div class="flex items-center w-full mt-1" style="gap:4px;">
                  <vs-button size="small" :disabled="!chartNo || !patientUsername || chartNoChecking" @click="checkAndReserveChartNo" color="primary" type="border" style="flex-shrink:0; white-space:nowrap;">
                    {{ chartNoChecking ? '확인 중...' : '중복확인' }}
                  </vs-button>
                  <span v-if="chartNoReserved && !chartNoDupWarning" class="text-success text-xs">✔ 사용 가능</span>
                  <span v-if="chartNoReserved && chartNoDupWarning" class="text-warning text-xs">⚠ 기존 환자와 차트번호 중복</span>
                  <span v-if="!chartNoReserved && chartNoDupWarning" class="text-danger text-xs">✖ 다른 담당자가 사용 중</span>
                </div>
                -->
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-input maxlength="10" v-validate="'required'" class="w-full" name="patientUsername" v-model="patientUsername" label="이름" placeholder="ex) 홍길동" />
                <span class="text-danger text-sm" v-show="errors.has('patientUsername')">이름을 입력해주세요</span>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-input
                    maxlength="14"
                    v-validate="'required'"
                    class="w-full"
                    name="jumin"
                    v-model="jumin"
                    label="주민등록번호"
                    placeholder="- 를 제외하고 입력해주세요."
                    @blur="juminCheck"
                    :id="'jumin'"
                    @keydown="juminAddString(jumin)"
                />
                <span class="text-danger text-sm" v-show="errors.has('jumin')">주민번호 입력</span>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3 ">
                <label for="" class="vs-input--label">생년월일</label>
                <date-picker disabled name="patientBirthday" v-model="patientBirthday" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select disabled autocomplete class="w-auto" name="patientGender" v-model="patientGender" label="성별" placeholder="ex) 남자">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item value="M" text="남자" />
                  <vs-select-item value="F" text="여자" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-input disabled type="number" class="w-full" name="age" v-model="age" label="나이" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-input
                    type="text"
                    maxlength="17"
                    class="w-full"
                    name="patientPhone"
                    v-model="patientPhone"
                    label="연락처"
                    placeholder="- 를 제외하고 입력해주세요."
                    @keyup="getPhoneMask(patientPhone, 'patientPhone')"
                />
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="address" v-model="address" label="주소지" placeholder="ex) 마포구(구단위까지)">
                  <div :key="index" v-for="(item, index) in addrOptions">
                    <vs-select-group :title="item.title" v-if="item.group">
                      <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in item.group" />
                    </vs-select-group>
                  </div>
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-input class="w-auto" name="oxygenPoint" v-model="oxygenPoint" label="산소포인트" @click="showOxygenCard = true" readonly="true">
                </vs-input>
              </div>
            </div>
            <template>
                <vx-card v-show="showOxygenCard" class="point-card">
                  <div class="flex justify-between items-center">
                    <h3>포인트 조정</h3>
                  </div>
                    <div class="flex justify-between items-center"> 
                      <!-- <vs-select
                        v-model="adjustedOxygenPoint"
                        placeholder="0"
                      >
                        <vs-select-item value="10" text="10" />
                        <vs-select-item value="20" text="20" />
                        <vs-select-item value="30" text="30" />
                        <vs-select-item value="50" text="50" />
                        <vs-select-item value="100" text="100" />
                        <vs-select-item value="직접입력" text="직접입력" />
                      </vs-select> -->
                      
                      <vs-input maxlength="15" class="w-1/3" lable="" v-model="adjustedOxygenPoint" />
                      <div>
                        <vs-button class="" color="success" @click="updateOxygenPoint(1)">적립</vs-button>
                        <vs-button class="" color="warning" @click="updateOxygenPoint(-1)">차감</vs-button>
                        <vs-button class="" color="primary" type="border" @click="showOxygenCard = false">닫기</vs-button>
                      </div>
                    </div>
                </vx-card>
            </template>
            <!--예진기록시작-->
            <vx-card ref="" title="예진기록" class="user-list-filters mb-8 collapsed" collapseAction>
              <div class="vx-row mb-3">
                <div :class="sickNess != '직접입력' ? 'vx-col w-full lg:w-1/3' : 'vx-col w-full lg:w-1/3'">
                  <vs-select autocomplete class="w-auto" name="sickNess" v-model="sickNess" label="진단명" placeholder="ex) 위암">
                    <vs-select-item value="직접입력" text="직접입력" />
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item :value="item.SICKNESS" :text="item.SICKNESS" v-for="(item, index) in sickNessList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3" v-show="sickNess == '직접입력'">
                  <vs-input maxlength="15" class="w-full" name="sickNessText" v-model="sickNessText" label="진단명 직접입력" placeholder="ex) 위암" />
                </div>
                <div class="vx-col w-full lg:w-1/3">
                  <vs-select autocomplete class="w-auto" name="bodyPart" v-model="bodyPart" label="부위" placeholder="ex) Lt">
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item :value="item.BODYPART" :text="item.BODYPART" v-for="(item, index) in bodyPartList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3">
                  <vs-input maxlength="5" class="w-full" name="gisu" v-model="gisu" label="기수" placeholder="ex) 3기" />
                </div>
                <div class="vx-col w-full lg:w-1/3">
                  <vs-select autocomplete v-model="patientPosition" label="환자 등급" placeholder="ex) 일반" class="w-full">
                    <vs-select-item value="1" text="일반" />
                    <vs-select-item value="2" text="VIP" />
                    <vs-select-item value="3" text="Black" />
                  </vs-select>
                </div>
              </div>
              <div class="vx-row mb-3">
                <!-- <label for="" class="vs-input--label">진단일</label> -->
                <!-- <date-picker name="diagnosisDate" v-model="diagnosisDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker> -->
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">진단일</label>
                  <vs-input name="diagnosisDate" v-model="diagnosisDate" class="vs-inputx normal w-full" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1">
                  <label for="" class="vs-input--label">수술</label>
                  <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                      <date-picker
                          name="operationDate"
                          v-model="operationDate"
                          :locale="'ko'"
                          valueType="format"
                          class="vs-inputx normal w-full"
                      ></date-picker>
                    </div>
                    <div class="vx-col w-full lg:w-2/3">
                      <vs-input name="operationName" v-model="operationName" :locale="'ko'" valueType="format" class="vs-inputx normal w-full" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <vs-input class="w-full" name="metastasisYn" v-model="metastasisYn" label="전이" />
                </div>
                <!-- <div class="vx-col w-full lg:w-1/1 ">
                                    <vs-input class="w-full" name="metastasisPart" v-model="metastasisPart" label="전이부위" placeholder="ex) 전이부위 작성" />
                                </div> -->
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">항암치료</label>
                  <vs-input name="anticancerDate" v-model="anticancerDate" class="vs-inputx normal w-full" />
                </div>
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">방사선치료</label>
                  <vs-input name="radiotherapyDate" v-model="radiotherapyDate" class="vs-inputx normal w-full" />
                </div>
              </div>
              <!-- <div class="vx-row mb-3">
                                <div class="vx-col w-full lg:w-1/1 ">
                                    <vs-input class="w-full" name="antiagent" v-model="antiagent" label="항암제" placeholder="ex) 항암제 작성" />
                                </div>
                            </div> -->
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="antiagentYn" v-model="antiagentYn" label="항암제" placeholder="ex) 유/무" v-show="1 == 2">
                    <vs-select-item :value="'Y'" :text="'유'" />
                    <vs-select-item :value="'N'" :text="'무'" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-3/3 " v-show="antiagentYn == 'Y'">
                  <vs-input class="w-full" name="antiagent" v-model="antiagent" label="항암제" placeholder="ex) 항암제 작성" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-3/3 ">
                  <vs-input class="w-full" name="medication" v-model="medication" label="원무부 미수관리" placeholder="ex) 원무부 미수 관리 작성" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="anamnesisYn" v-model="anamnesisYn" label="기왕력" placeholder="ex) 유/무">
                    <vs-select-item :value="'Y'" :text="'유'" />
                    <vs-select-item :value="'N'" :text="'무'" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-2/3 " v-show="anamnesisYn == 'Y'">
                  <template>
                    <ul class="centerx">
                      <label for="" class="vs-select--label">기왕력 상세</label>
                      <li v-for="(item, index) in anamnesisList" :key="index">
                        <vs-checkbox v-model="anamnesis" :vs-value="item.ANAMNESIS" @input="anamnesisInput">{{ item.ANAMNESIS }}</vs-checkbox>
                        <vs-input
                            :disabled="anamnesis.indexOf('기타') < 0"
                            class="w-full"
                            name="anamnesisEtc"
                            v-model="anamnesisEtc"
                            placeholder="ex) 기타 작성"
                            v-if="item.ANAMNESIS == '기타'"
                        />
                      </li>
                    </ul>
                  </template>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">실비보험현황</label>
                  <vs-input name="etcMemo" v-model="etcMemo" class="vs-inputx normal w-full" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">병실관련 메모</label>
                  <vs-input name="roomMemo" v-model="roomMemo" class="vs-inputx normal w-full" />
                </div>
              </div>
            </vx-card>
            <!--예진기록끝-->
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <div class="vx-row mb-3">
              <div :class="medicalName != '직접입력' ? 'vx-col w-full lg:w-2/3' : 'vx-col w-full lg:w-1/3'">
                <vs-select autocomplete class="w-auto" name="medicalName" v-model="medicalName" label="본병원" placeholder="ex) 세브란스신촌">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEDICAL_CENTER_NAME" :text="item.MEDICAL_CENTER_NAME" v-for="(item, index) in medicalCenterList" :key="index" />
                  <vs-select-item value="직접입력" text="직접입력" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-2/3" v-show="medicalName == '직접입력'">
                <vs-input maxlength="15" class="w-full" name="medicalNameText" v-model="medicalNameText" label="본병원" placeholder="ex) 세브란스신촌" />
              </div>
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select autocomplete class="w-auto" name="kakao_sender" v-model="kakao_sender" label="알림톡 수신자">
                  <vs-select-item value="1" text="환자본인" />
                  <vs-select-item value="2" text="보호자" />
                  <vs-select-item value="3" text="보호자2" />
                </vs-select>
              </div>
            </div>
            <vs-divider color="danger">보호자</vs-divider>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select autocomplete class="w-auto" name="protector" v-model="protector" label="보호자관계" placeholder="ex) 딸">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.PROTECTOR_CODE" :text="item.PROTECTOR" v-for="(item, index) in protectorList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-2/3">
                <vs-input
                    type="text"
                    maxlength="13"
                    class="w-full"
                    name="protectorPhone"
                    v-model="protectorPhone"
                    label="보호자연락처"
                    placeholder="- 를 제외하고 입력해주세요."
                    @keyup="getPhoneMask(protectorPhone, 'protectorPhone')"
                />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select autocomplete class="w-auto" name="protector2" v-model="protector2" label="보호자2관계" placeholder="ex) 아들">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.PROTECTOR_CODE" :text="item.PROTECTOR" v-for="(item, index) in protectorList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-2/3">
                <vs-input
                    type="text"
                    maxlength="13"
                    class="w-full"
                    name="protectorPhone2"
                    v-model="protectorPhone2"
                    label="보호자2연락처"
                    placeholder="- 를 제외하고 입력해주세요."
                    @keyup="getPhoneMask(protectorPhone2, 'protectorPhone2')"
                />
              </div>
            </div>
            <vs-divider color="danger"></vs-divider>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-input class="w-full" name="newRe" v-model="newRe" label="신입재입" maxlength="5" disabled />
              </div>
              <div :class="cdStatus != '' && cdStatus != 6 && cdStatus != 9 && cdStatus != 11 && cdStatus != 12 && cdStatus != 13 ? 'vx-col w-full lg:w-1/3' : 'vx-col w-full lg:w-2/3'">
                <template>
                  <vs-select
                      v-validate="'required'"
                      autocomplete
                      class="w-auto"
                      name="cdStatus"
                      v-model="cdStatus"
                      label="현재상태"
                      placeholder="현재상태 선택"
                      @input="cdStatusChange()"
                  >
                    <vs-select-item :value="item.CD_STATUS" :text="item.STATUS_NAME" v-for="(item, index) in statusList" :key="index" />
                  </vs-select>
                </template>

                <span class="text-danger text-sm" v-show="errors.has('cdStatus')">현재상태 선택해주세요</span>
              </div>

              <div class="vx-col w-full lg:w-1/3" v-show="cdStatus != '' && cdStatus != 6 && cdStatus != 9 && cdStatus != 11 && cdStatus != 12 && cdStatus != 13 && cdStatus != 14">
                <vs-select
                    v-validate="'required'"
                    autocomplete
                    class="w-auto"
                    name="medicalRoomNumberNmEtc"
                    v-model="medicalRoomNumberNm"
                    label="세부 선택"
                    placeholder="현재상태 세부 선택"
                >
                  <vs-select-item
                      :value="item2.MEDICAL_ROOM_NUMBER_NM"
                      :text="item2.MEDICAL_ROOM_NM + ' - ' + item2.MEDICAL_ROOM_NUMBER_NM"
                      v-for="(item2, index2) in medicalRoomNumberListEtc"
                      :key="index2"
                  />
                </vs-select>
                <span class="text-danger text-sm" v-show="errors.has('medicalRoomNumberNmEtc')">세부 선택해주세요.</span>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3 ">
                <label for="" class="vs-input--label">최초입원일</label>
                <date-picker
                    name="inInitDate"
                    v-model="inInitDate"
                    :locale="'ko'"
                    valueType="format"
                    class="vs-inputx normal w-full"
                    @input="
                                        [
                                        dateInit(),
                                        dateStatusChange(),
                                        statusCheck(completeYn, inInitDate, inDate, outDate)
                                        ]"
                ></date-picker>
              </div>
              <div class="vx-col w-full lg:w-1/3 ">
                <label for="" class="vs-input--label">입원예정일</label>
                <date-picker
                    name="inDate"
                    v-model="inDate"
                    :locale="'ko'"
                    valueType="format"
                    :disabled="inInitDate == null || inInitDate.length <= 0"
                    class="vs-inputx normal w-full"
                    @input="
                                        [
                                        dateStatusChange(),
                                        statusCheck(completeYn, inInitDate, inDate, outDate),
                                        inTimeReset(),
                                        ]"
                ></date-picker>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-input minlength="4" maxlength="4" class="w-full" name="inTime" v-model="inTime" label="입원예정시간(hhmm)" placeholder="오후2시 30분 = 1430" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3 ">
                <label for="" class="vs-input--label">퇴원예정일</label>
                <date-picker
                    name="outDate"
                    v-model="outDate"
                    :locale="'ko'"
                    valueType="format"
                    :disabled="inInitDate == null || inInitDate.length <= 0"
                    class="vs-inputx normal w-full"
                    @input="
                                        [
                                        dateStatusChange(),
                                        statusCheck(completeYn, inInitDate, inDate, outDate)
                                        ]"
                ></date-picker>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-input minlength="4" maxlength="4" class="w-full" name="outTime" v-model="outTime" label="퇴원예정시간(hhmm)" placeholder="오전 11시 30분 = 1130" />
              </div>
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select
                    autocomplete
                    class="w-auto"
                    name="completeYn"
                    v-model="completeYn"
                    label="완퇴여부"
                    placeholder="ex) Y"
                    @input="statusCheck(completeYn, inInitDate, inDate, outDate)"
                >
                  <vs-select-item value="Y" text="Y" />
                  <vs-select-item value="N" text="N" />
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="mealTime" v-model="mealTime" label="식사구분" placeholder="ex) 아침">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEALTIME_NM" :text="item.MEALTIME_NM" v-for="(item, index) in mealTimeList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="mealName" v-model="mealName" label="입원일 식이" placeholder="ex) 일반식 현미밥">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="mealMemo" v-model="mealMemo" label="입원일 식이 비고" placeholder="ex) 밥추가, 보호자식">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEALMEMO" :text="item.MEALMEMO" v-for="(item, index) in mealMemoList" :key="index" />
                  <vs-select-item value="직접입력" text="직접입력" />
                </vs-select>
              </div>
            </div>
            <div class="pt-2 pb-2">
              기준식이
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="breakfast_mealName" v-model="breakfast_mealName" label="아침" placeholder="ex) 일반식 현미밥">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="lunch_mealName" v-model="lunch_mealName" label="점심" placeholder="ex) 일반식 현미밥">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="dinner_mealName" v-model="dinner_mealName" label="저녁" placeholder="ex) 일반식 현미밥">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEALNAME" :text="item.MEALNAME" v-for="(item, index) in mealNameList" :key="index" />
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-3" v-show="mealMemo == '직접입력'">
              <div class="vx-col w-full lg:w-3/3">
                <vs-input maxlength="15" class="w-full" name="mealMemoText" v-model="mealMemoText" label="입원일 식이 비고" placeholder="ex) 밥추가, 보호자식" />
              </div>
            </div>
            <div class="vx-row mb-3" v-show="cdStatus == 6 || cdStatus == 9 || cdStatus == 11 || cdStatus == 12 || cdStatus == 13 || cdStatus == 14">
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select autocomplete class="w-auto" name="medicalRoomNm" v-model="medicalRoomNm" label="병동선택" placeholder="ex) 2병동" @input="medicalRoomChange()">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item2.MEDICAL_ROOM_NM" :text="item2.MEDICAL_ROOM_NM" v-for="(item2, index2) in medicalRoomList" :key="index2" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select
                    v-validate="'required'"
                    autocomplete
                    class="w-auto"
                    name="medicalRoomNumberNm"
                    v-model="medicalRoomNumberNm"
                    label="병실선택"
                    placeholder="ex) 201호"
                    @input="medicalRoomNumberChange()"
                >
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item2.MEDICAL_ROOM_NUMBER_NM" :text="item2.MEDICAL_ROOM_NUMBER_NM" v-for="(item2, index2) in medicalRoomNumberList2" :key="index2" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select autocomplete class="w-auto" name="medicalRoomNumberCnt" v-model="medicalRoomNumberCnt" label="베드위치" placeholder="ex) 1">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="String(item2.NEXT_CD)" :text="String(item2.NEXT_CD)" v-for="(item2, index2) in medicalRoomNumberCntList" :key="index2" />
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-select v-validate="'required'" autocomplete class="w-auto" name="medical_member_name" v-model="medical_member_name" label="한방주치의" placeholder="ex) 홍길동">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEDICAL_NM" :text="item.MEDICAL_NM" v-for="(item, index) in medicalMemberList" :key="index" />
                </vs-select>
                <span class="text-danger text-sm" v-show="errors.has('medical_member_name')">한방주치의 선택해주세요</span>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="westMedicalNm" v-model="westMedicalNm" label="양방주치의" placeholder="ex) 홍길동">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEDICAL_NM" :text="item.MEDICAL_NM" v-for="(item, index) in medicalMemberList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="consultDoctorUid" v-model="consultDoctorUid" label="병동주치의" placeholder="ex) 홍길동">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEDICAL_CD" :text="item.MEDICAL_NM" v-for="(item, index) in medicalMemberList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3" v-show="false">
                <vs-select autocomplete class="w-auto" name="corona" v-model="corona" label="코로나검사여부" placeholder="ex) PCR">
                  <vs-select-item :value="item.CORONA" :text="item.CORONA" v-for="(item, index) in coronaList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select autocomplete class="w-auto" name="inFlowPath" v-model="inFlowPath" label="메디람 처음 안 곳" placeholder="ex) 유튜브">
                  <vs-select-item :value="item.INFLOW_ID" :text="item.INFLOW_NAME" v-for="(item, index) in inFlowList" :key="index" />
                </vs-select>
              </div>
            </div>
            <div class="vx-row mb-6 mt-6">
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-checkbox v-model="expire">
                  Expire
                </vs-checkbox>
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input class="w-full" name="plan" v-model="plan" label="치료플랜" placeholder="ex) 상담실 통해 확인 필요" />
              </div>
            </div>
            <div class="vx-row mb-3" v-if="userLevel <= 5">
              <div class="vx-col w-full lg:w-1/1 ">
                <label for="" class="vs-input--label">상담 메모</label>
                <vs-input name="csMemo" v-model="csMemo" class="vs-inputx normal w-full" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input class="w-full" name="nutritionMemo" v-model="nutritionMemo" label="영양메모" placeholder="영양메모란" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full">
                <vs-input class="w-full" name="memo" v-model="memo" label="기타사항" placeholder="ex) 1인실 희망" />
              </div>
            </div>
          </div>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full text-right">
            <vs-button class="mr-3 mb-2" @click="onClickModify('b')">저장</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click="onClickModifyHide">닫기</vs-button>
          </div>
        </div>
      </form>
    </vs-popup>

    <!--상담내역팝업시작-->
    <vs-popup id="csPopup" title="상담내역" :active.sync="csPopup">
      <form @submit.prevent>
        <div class="vx-row mb-3">
          <vs-button type="line" :class="activeMenu2(1)" @click="popTabClick(1)">환자관리</vs-button>
          <vs-button type="line" :class="activeMenu2(2)" @click="popTabClick(2)" v-show="tab_sum & 1024">상담내역</vs-button>
        </div>

        <div class="vx-row">
          <div class="vx-col w-full lg:w-1/2">
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-input maxlength="10" v-validate="'required'" class="w-full" name="patientUsername" v-model="patientUsername" label="이름" placeholder="ex) 홍길동" />
                <span class="text-danger text-sm" v-show="errors.has('patientUsername')">이름을 입력해주세요</span>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="patientGender" v-model="patientGender" label="성별" placeholder="ex) 남자">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item value="M" text="남자" />
                  <vs-select-item value="F" text="여자" />
                </vs-select>
              </div>
              <div :class="medicalName != '직접입력' ? 'vx-col w-full lg:w-1/3' : 'vx-col w-full lg:w-1/3'">
                <vs-select autocomplete class="w-auto" name="medicalName" v-model="medicalName" label="본병원" placeholder="ex) 세브란스신촌">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.MEDICAL_CENTER_NAME" :text="item.MEDICAL_CENTER_NAME" v-for="(item, index) in medicalCenterList" :key="index" />
                  <vs-select-item value="직접입력" text="직접입력" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3" v-show="medicalName == '직접입력'">
                <vs-input maxlength="15" class="w-full" name="medicalNameText" v-model="medicalNameText" label="본병원" placeholder="ex) 세브란스신촌" />
              </div>
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-input type="number" class="w-full" name="age" v-model="age" label="나이" />
              </div>
              <div class="vx-col w-full lg:w-1/3" v-show="false">
                <vs-select autocomplete class="w-auto" name="corona" v-model="corona" label="코로나검사여부" placeholder="ex) PCR">
                  <vs-select-item :value="item.CORONA" :text="item.CORONA" v-for="(item, index) in coronaList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3 ">
                <vs-select autocomplete class="w-auto" name="inFlowPath" v-model="inFlowPath" label="메디람 처음 안 곳" placeholder="ex) 유튜브">
                  <vs-select-item :value="item.INFLOW_ID" :text="item.INFLOW_NAME" v-for="(item, index) in inFlowList" :key="index" />
                </vs-select>
              </div>
              <!-- <div :class="sickNess != '직접입력' ? 'vx-col w-full lg:w-1/3' : 'vx-col w-full lg:w-1/3'">
                                <vs-select autocomplete class="w-auto" name="sickNess" v-model="sickNess" label="진단명" placeholder="ex) 위암">
                                    <vs-select-item value="직접입력" text="직접입력" />
                                    <vs-select-item value="" text="초기값" />
                                    <vs-select-item :value="item.SICKNESS" :text="item.SICKNESS" v-for="(item, index) in sickNessList" :key="index" />
                                </vs-select>
                            </div>
                            <div class="vx-col w-full lg:w-1/3" v-show="sickNess == '직접입력'">
                                <vs-input maxlength="15" class="w-full" name="sickNessText" v-model="sickNessText" label="진단명 직접입력" placeholder="ex) 위암" />
                            </div>
                            <div class="vx-col w-full lg:w-1/3">
                                <vs-select autocomplete class="w-auto" name="bodyPart" v-model="bodyPart" label="부위" placeholder="ex) Lt">
                                    <vs-select-item value="" text="초기값" />
                                    <vs-select-item :value="item.BODYPART" :text="item.BODYPART" v-for="(item, index) in bodyPartList" :key="index" />
                                </vs-select>
                            </div> -->
            </div>
            <div class="vx-row mb-3">
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="mainCs" v-model="mainCs" label="주상담자" placeholder="선택">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item :value="item.UID" :text="item.USERNAME" v-for="(item, index) in mainCsMemberList" :key="index" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-select autocomplete class="w-auto" name="mainCsCaller" v-model="mainCsCaller" label="주문의자" placeholder="선택" @input="mainCsCallerChange(mainCsCaller)">
                  <vs-select-item value="" text="초기값" />
                  <vs-select-item value="1" text="환자본인" />
                  <vs-select-item value="2" text="보호자" />
                  <vs-select-item value="3" text="보호자2" />
                </vs-select>
              </div>
              <div class="vx-col w-full lg:w-1/3">
                <vs-input
                    maxlength="13"
                    class="w-full"
                    name="mainCsCallerPhone"
                    v-model="mainCsCallerPhone"
                    label="주문의자 연락처"
                    placeholder=""
                    @keyup="getPhoneMask(mainCsCallerPhone, 'mainCsCallerPhone')"
                    disabled
                />
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full text-center">
                <vs-button class="mb-1" color="warning" @click="onClickModifyCs()">저장</vs-button>
              </div>
            </div>
            <vx-card ref="" title="기본정보" class="user-list-filters mb-8 collapsed" collapseAction>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/2">
                  <vs-select autocomplete v-model="initPath" label="최초 경로" placeholder="ex) 전화" class="w-full">
                    <vs-select-item value="" text="선택" />
                    <vs-select-item value="1" text="전화" />
                    <vs-select-item value="2" text="홈페이지" />
                    <vs-select-item value="3" text="카카오톡" />
                    <vs-select-item value="4" text="힐링미" />
                    <vs-select-item value="5" text="예약없이방문" />
                    <vs-select-item value="6" text="기타" />
                  </vs-select>
                </div>

                <div class="vx-col w-full lg:w-1/2">
                  <vs-select autocomplete v-model="patientPosition" label="환자 등급" placeholder="ex) 일반" class="w-full">
                    <vs-select-item value="1" text="일반" />
                    <vs-select-item value="2" text="VIP" />
                    <vs-select-item value="3" text="Black" />
                  </vs-select>
                </div>

                <!-- <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csPathCode" v-model="data.CS_PATH_CODE" label="경로" placeholder="ex) 전화">
                                <vs-select-item :value="item.CS_PATH_CODE" :text="item.CS_PATH" v-for="(item, index) in csPathList" :key="index" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csCateCode" v-model="data.CS_CATE_CODE" label="문의종류" placeholder="ex) 신규">
                                <vs-select-item :value="item.CS_CATE_CODE" :text="item.CS_CATE" v-for="(item, index) in csCateList" :key="index" />
                            </vs-select>
                        </div>
                        <div class="vx-col w-full lg:w-1/3 ">
                            <vs-select autocomplete class="w-auto" name="csMeberCode" v-model="data.CS_MEMBER_CODE" label="담당자" placeholder="ex) 담당자 선택">
                                <vs-select-item :value="item.CS_MEMBER_CODE" :text="item.CS_MEMBER" v-for="(item, index) in csMemberList" :key="index" />
                            </vs-select>
                        </div> -->
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/3">
                  <vs-input
                      type="text"
                      maxlength="13"
                      class="w-full"
                      name="patientPhone"
                      v-model="patientPhone"
                      label="연락처"
                      placeholder="- 를 제외하고 입력해주세요."
                      @keyup="getPhoneMask(patientPhone, 'patientPhone')"
                  />
                </div>
                <div class="vx-col w-full lg:w-2/3">
                  <vs-select autocomplete class="w-auto" name="address" v-model="address" label="주소지" placeholder="ex) 마포구(구단위까지)">
                    <div :key="index" v-for="(item, index) in addrOptions">
                      <vs-select-group :title="item.title" v-if="item.group">
                        <vs-select-item :key="index" :value="item.value" :text="item.text" v-for="(item, index) in item.group" />
                      </vs-select-group>
                    </div>
                  </vs-select>
                </div>
              </div>
              <vs-divider color="danger">보호자</vs-divider>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="protector" v-model="protector" label="보호자관계" placeholder="ex) 딸">
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item :value="item.PROTECTOR_CODE" :text="item.PROTECTOR" v-for="(item, index) in protectorList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-2/3">
                  <vs-input
                      type="text"
                      maxlength="13"
                      class="w-full"
                      name="protectorPhone"
                      v-model="protectorPhone"
                      label="보호자연락처"
                      placeholder="- 를 제외하고 입력해주세요."
                      @keyup="getPhoneMask(protectorPhone, 'protectorPhone')"
                  />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="protector2" v-model="protector2" label="보호자2관계" placeholder="ex) 아들">
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item :value="item.PROTECTOR_CODE" :text="item.PROTECTOR" v-for="(item, index) in protectorList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-2/3">
                  <vs-input
                      type="text"
                      maxlength="16"
                      class="w-full"
                      name="protectorPhone2"
                      v-model="protectorPhone2"
                      label="보호자2연락처"
                      placeholder="- 를 제외하고 입력해주세요."
                      @keyup="getPhoneMask(protectorPhone2, 'protectorPhone2')"
                  />
                </div>
              </div>
              <vs-divider color="danger"></vs-divider>
              <div class="vx-row mb-3">
                <div :class="sickNess != '직접입력' ? 'vx-col w-full lg:w-1/3' : 'vx-col w-full lg:w-1/3'">
                  <vs-select autocomplete class="w-auto" name="sickNess" v-model="sickNess" label="진단명" placeholder="ex) 위암">
                    <vs-select-item value="직접입력" text="직접입력" />
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item :value="item.SICKNESS" :text="item.SICKNESS" v-for="(item, index) in sickNessList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3" v-show="sickNess == '직접입력'">
                  <vs-input maxlength="15" class="w-full" name="sickNessText" v-model="sickNessText" label="진단명 직접입력" placeholder="ex) 위암" />
                </div>
                <div class="vx-col w-full lg:w-1/3">
                  <vs-select autocomplete class="w-auto" name="bodyPart" v-model="bodyPart" label="부위" placeholder="ex) Lt">
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item :value="item.BODYPART" :text="item.BODYPART" v-for="(item, index) in bodyPartList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3">
                  <vs-input maxlength="5" class="w-full" name="gisu" v-model="gisu" label="기수" placeholder="ex) 3기" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <!-- <label for="" class="vs-input--label">진단일</label> -->
                <!-- <date-picker name="diagnosisDate" v-model="diagnosisDate" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker> -->
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">진단일</label>
                  <vs-input name="diagnosisDate" v-model="diagnosisDate" class="vs-inputx normal w-full" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">전이</label>
                  <vs-input name="metastasisYn" v-model="metastasisYn" class="vs-inputx normal w-full" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">수술</label>
                  <div class="vx-row mb-3">
                    <div class="vx-col w-full lg:w-1/3">
                      <date-picker
                          name="operationDate"
                          v-model="operationDate"
                          :locale="'ko'"
                          valueType="format"
                          class="vs-inputx normal w-full"
                      ></date-picker>
                    </div>
                    <div class="vx-col w-full lg:w-2/3">
                      <vs-input name="operationName" v-model="operationName" :locale="'ko'" valueType="format" class="vs-inputx normal w-full" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">항암치료</label>
                  <vs-input name="anticancerDate" v-model="anticancerDate" class="vs-inputx normal w-full" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">방사선치료</label>
                  <vs-input name="radiotherapyDate" v-model="radiotherapyDate" class="vs-inputx normal w-full" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <vs-input class="w-full" name="antiagent" v-model="antiagent" label="항암제" placeholder="ex) 항암제 작성" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-3/3 ">
                  <vs-input class="w-full" name="medication" v-model="medication" label="복용약" placeholder="ex) 복용약 작성" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">기타 의학적 내용</label>
                  <vs-textarea name="etcMemo"  rows="5" auto-grow v-model="etcMemo" class="vs-inputx normal w-full"></vs-textarea>
                  <!-- <vs-input name="etcMemo" v-model="etcMemo" class="vs-inputx normal w-full" /> -->
                </div>
              </div>
              <div class="vx-row mb-3" v-if="userLevel <= 5">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">상담 메모</label>
                  <vs-textarea name="csMemo" rows="3" v-model="csMemo" class="vs-inputx normal w-full" />
                </div>
              </div>

              <label for="" class="vs-input--label">병실우선순위</label>
              <div class="vx-row mb-3">
                <!-- <div class="vx-col w-1/4" v-for="(item, index) in roomlist" :key="index">
                  <vs-checkbox type="checkbox" :vs-value="item.TAB_CODE" v-model="tabArray_01" :id="'tab_01_' + index"> {{ item.TAB_NAME }}</vs-checkbox>
                </div> -->
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select
                      autocomplete
                      class="w-auto"
                      name="wantedRoom1"
                      v-model="wantedRoom1"
                      label="1순위"
                  >
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item value="a1" text="1인실" />
                    <vs-select-item value="a2" text="2인실" />
                    <vs-select-item value="a3" text="3인실" />
                    <vs-select-item value="a4" text="4인실" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select
                      autocomplete
                      class="w-auto"
                      name="wantedRoom2"
                      v-model="wantedRoom2"
                      label="2순위"
                  >
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item value="b1" text="1인실" />
                    <vs-select-item value="b2" text="2인실" />
                    <vs-select-item value="b3" text="3인실" />
                    <vs-select-item value="b4" text="4인실" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select
                      autocomplete
                      class="w-auto"
                      name="wantedRoom3"
                      v-model="wantedRoom3"
                      label="3순위"
                  >
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item value="c1" text="1인실" />
                    <vs-select-item value="c2" text="2인실" />
                    <vs-select-item value="c3" text="3인실" />
                    <vs-select-item value="c4" text="4인실" />
                  </vs-select>
                </div>
              </div>

              <!--실비보험구간-->
              <div class="vx-col w-full lg:w-2/2">
                <div class="vx-row mb-3">
                  <div
                      :class="
                                    insuranceChk == false
                                        ? 'vx-col w-full lg:w-2/3'
                                        : 'vx-col w-full lg:w-3/3'
                                    "
                  >
                    <label for="" class="vs-input--label"></label>
                    <vs-checkbox v-model="insuranceChk" >실비보험</vs-checkbox>
                    <div class="vx-row mb-3" style="margin-top: 10px;">
                      <div
                          class="vx-col w-full lg:w-3/3"
                          v-show="insuranceChk == true"
                      >
                        <div class="vx-row mb-3">
                          <div class="vx-col w-1/2 lg:w-1/1">
                            <label for="" class="vs-input--label">보험사</label>
                            <vs-select
                                autocomplete
                                class="w-auto"
                                name="insuranceName"
                                v-model="insuranceName"
                                label=""
                                placeholder="ex) 삼성"
                            >
                              <vs-select-item value="" text="초기값" />
                              <vs-select-item value="직접입력" text="직접입력" />
                              <vs-select-item
                                  :value="item.INSURANCE_CENTER_CODE"
                                  :text="item.INSURANCE_CENTER_NAME"
                                  v-for="(item, index) in insuranceCenterList"
                                  :key="index"
                              />
                            </vs-select>
                          </div>
                          <div class="vx-col w-1/2 lg:w-1/1">
                            <label for="" class="vs-input--label">가입시기</label>
                            <vs-select
                                autocomplete
                                class="w-auto"
                                name="silbiJoinPeriod"
                                v-model="silbiJoinPeriod"
                                label=""
                                placeholder="ex) 삼성"
                            >
                              <vs-select-item value="" text="초기값" />
                              <vs-select-item
                                  :value="item.SILBI_JOIN_PERIOD_CODE"
                                  :text="item.SILBI_JOIN_PERIOD_NAME"
                                  v-for="(item, index) in silbiJoinPeriodList"
                                  :key="index"
                              />
                            </vs-select>
                          </div>
                        </div>
                        <div class="vx-row mb-3" v-show="insuranceName == '직접입력'">
                          <div class="vx-col w-full lg:w-3/3" style="margin-top: 10px;">
                            <vs-input
                                maxlength="15"
                                class="w-full"
                                name="insuranceNameText"
                                v-model="insuranceNameText"
                                label="보험사"
                                placeholder="ex) 삼성"
                            />
                          </div>
                          <div class="vx-col w-full lg:w-1/3" style="margin-top: 10px;">
                            <label for="" class="vs-input--label">가입연도</label>
                            <date-picker
                                name="joinDate"
                                v-model="joinDate"
                                :locale="'ko'"
                                valueType="format"
                                class="vs-inputx normal w-full"
                            ></date-picker>
                          </div>
                        </div>
                        <div class="vx-row mb-5"></div>
                        <!--입원한도구간-->
                        <div class="vx-row mb-3">
                          <div class="vx-col w-full lg:w-3/3 ">
                            <label for="" class="vs-input--label">입원한도</label>
                            <div class="vx-row mb-3">
                              <div class="vx-col w-1/4">
                                <vs-radio vs-value="1" v-model="inLimit">1억</vs-radio>
                              </div>
                              <div class="vx-col w-1/4">
                                <vs-radio vs-value="5" v-model="inLimit">5천</vs-radio>
                              </div>
                              <div class="vx-col w-1/4">
                                <vs-radio vs-value="3" v-model="inLimit">3천</vs-radio>
                              </div>
                              <div class="vx-col w-1/4">
                                <vs-radio vs-value="etc" v-model="inLimit">기타</vs-radio>
                              </div>
                            </div>
                            <div
                                class="vx-col w-full lg:w-1/3"
                                v-show="inLimit == 'etc'"
                            >
                              <vs-input
                                  maxlength="15"
                                  class="w-full"
                                  name="inLimitText"
                                  v-model="inLimitText"
                                  label="입원한도"
                                  placeholder="ex) 1억"
                              />
                            </div>
                          </div>
                        </div>
                        <label for="" class="vs-input--label">입원 보장율</label>
                        <div class="vx-row mb-3">
                          <div class="vx-col w-1/4">
                            <vs-radio vs-value="100" v-model="inGuarantee">100%</vs-radio>
                          </div>
                          <div class="vx-col w-1/4">
                            <vs-radio vs-value="90" v-model="inGuarantee">90%</vs-radio>
                          </div>
                          <div class="vx-col w-1/4">
                            <vs-radio vs-value="80" v-model="inGuarantee">80%</vs-radio>
                          </div>
                          <div class="vx-col w-1/4">
                            <vs-radio vs-value="70" v-model="inGuarantee">70%</vs-radio>
                          </div>
                        </div>


                        <!--잔액구간-->
                        <div class="vx-row mb-3">
                          <div class="vx-col w-full lg:w-1/3 ">
                            <label for="" class="vs-input--label">현재 잔액</label>
                            <vs-input
                                name="balance"
                                v-model="balance"
                                type="number"
                                class="vs-inputx normal w-full"
                            />
                          </div>
                          <div class="vx-col w-full lg:w-3/3" v-show="balance != ''">
                            <div class="vx-col w-full lg:w-1/3">
                              <div class="vx-col w-full lg:w-1/1 ">
                                <label for="" class="vs-input--label">확인일</label>
                                <date-picker
                                    name="confirmDate"
                                    v-model="confirmDate"
                                    :locale="'ko'"
                                    valueType="format"
                                    class="vs-inputx normal w-full"
                                ></date-picker>
                              </div>
                            </div>
                          </div>


                        </div>
                        <!--통원구간-->
                        <div class="vx-row mb-3">
                          <div class="vx-col w-full lg:w-3/3 ">
                            <div
                                :class="
                                                outpatDayLimit != 'ETC'
                                                    ? 'vx-col w-full lg:w-3/3'
                                                    : 'vx-col w-full lg:w-3/3'
                                                "
                            >

                              <label for="" class="vs-input--label">통원 일한도</label>
                              <div class="vx-row mb-3">
                                <div class="vx-col w-1/5">
                                  <vs-radio vs-value="10" v-model="outpatDayLimit">10</vs-radio>
                                </div>
                                <div class="vx-col w-1/5">
                                  <vs-radio vs-value="20" v-model="outpatDayLimit">20</vs-radio>
                                </div>
                                <div class="vx-col w-1/5">
                                  <vs-radio vs-value="25" v-model="outpatDayLimit">25</vs-radio>
                                </div>
                                <div class="vx-col w-1/5">
                                  <vs-radio vs-value="30" v-model="outpatDayLimit">30</vs-radio>
                                </div>
                                <div class="vx-col w-1/5">
                                  <vs-radio vs-value="ETC" v-model="outpatDayLimit">기타</vs-radio>
                                </div>
                              </div>

                            </div>
                            <div
                                class="vx-col w-full lg:w-1/4"
                                v-show="outpatDayLimit == 'ETC'"
                            >
                              <vs-input
                                  maxlength="15"
                                  class="w-full"
                                  name="outpatDayLimitText"
                                  v-model="outpatDayLimitText"
                                  label="통원 일한도(기타입력)"
                                  placeholder=""
                              />
                            </div>
                          </div>
                        </div>
                        <div class="vx-col w-full mb-3 lg:w-full">
                          <div class="vx-col w-full lg:w-full ">
                            <div class="vx-row mb-3">
                              <div class="vx-col w-1/2 lg:w-1/1 ">
                                <label for="" class="vs-input--label">면책 시작일</label>
                                <date-picker
                                    name="indemStdt"
                                    v-model="indemStdt"
                                    :locale="'ko'"
                                    valueType="format"
                                    class="vs-inputx normal w-full"
                                ></date-picker>
                              </div>
                              <div class="vx-col w-1/2 lg:w-1/1">
                                <div class="vx-col w-full lg:w-1/1 ">
                                  <label for="" class="vs-input--label">면책 종료일</label>
                                  <date-picker
                                      name="indemEnddt"
                                      v-model="indemEnddt"
                                      :locale="'ko'"
                                      valueType="format"
                                      class="vs-inputx normal w-full"
                                  ></date-picker>
                                </div>
                              </div>
                            </div>
                            <div class="vx-col w-1/3 lg:w-1/1 ">
                              <label for="" class="vs-input--label">통원 횟수</label>
                              <vs-input
                                  name="outPatCount"
                                  v-model="outPatCount"
                                  type="number"
                                  class="vs-inputx normal w-full"
                              />
                            </div>
                            <div class="vx-col w-full lg:w-1/1 ">
                              <label for="" class="vs-input--label">실비 관련 기타 메모만 입력</label>
                              <vs-input name="cs3Memo" v-model="cs3Memo" class="vs-inputx normal w-full" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!--보험면책-->
                  </div>
                </div>
              </div>
              <div  class="vx-col w-full lg:w-full">
                <div class="vx-row mb-3">
                  <div class="vx-col w-full mb-3 lg:w-full">
                    <vs-checkbox
                        v-model="etcSchedule"
                    >기타스케쥴</vs-checkbox>
                    <!-- icon-pack="feather" icon="icon-chevron-right"  -->
                    <!-- @click="changeEtcSchedule()" -->
                  </div>
                  <div
                      class="vx-col w-full lg:w-full"
                      v-show="etcSchedule == true"
                  >
                    <div class="vx-row mb-3">
                      <div class="vx-col w-full lg:w-1/2">
                        <div class="vx-col w-full lg:w-1/1 ">
                          <label for="" class="vs-input--label">F/U</label>
                          <date-picker
                              name="followUpDate"
                              v-model="followUpDate"
                              :locale="'ko'"
                              valueType="format"
                              class="vs-inputx normal w-full"
                          ></date-picker>
                        </div>
                      </div>
                      <div class="vx-col w-full lg:w-1/2">
                        <div class="vx-col w-full lg:w-1/1 ">
                          <label for="" class="vs-input--label">검사</label>
                          <date-picker
                              name="inspectionDate"
                              v-model="inspectionDate"
                              :locale="'ko'"
                              valueType="format"
                              class="vs-inputx normal w-full"
                          ></date-picker>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 기존 구간-->
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/1 ">
                  <label for="" class="vs-input--label">보험 메모</label>
                  <vs-input name="cs2Memo" v-model="cs2Memo" class="vs-inputx normal w-full" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full">
                  <vs-input class="w-full" name="nutritionMemo" v-model="nutritionMemo" label="영양메모" placeholder="영양메모란" />
                </div>
              </div>
              <div class="vx-row mb-3">
                <div class="vx-col w-full">
                  <vs-input class="w-full" name="memo" v-model="memo" label="기타사항" placeholder="ex) 1인실 희망" />
                </div>
              </div>
            </vx-card>
            <div class="vx-row">
              <div class="vx-col w-full text-center">
                <vs-button class="mb-1" color="warning" @click="onClickModifyCs()">기본저장</vs-button>
              </div>
            </div>
          </div>
          <div class="vx-col w-full lg:w-1/2">
            <div class="vx-row">
              <div class="vx-col w-full text-right">
                <vs-button class="mb-1" color="success" @click="addClickCs">(+)추가</vs-button>
                <vs-button class="ml-3" @click="onClickModifyCs()" v-show="csDatas.length > 0">상담내역 저장</vs-button>
              </div>
            </div>
            
            <!-- 상담내역 카드 목록 (성능 개선) -->
            <div class="cs-cards-container" ref="csCardsContainer" @scroll="handleCsScroll">
              <vx-card 
                ref="" 
                :title="data.CS_DATE + ' ' + data.CS_TIME" 
                class="user-list-filters mb-8" 
                v-for="(data, data_index) in displayedCsDatas" 
                :key="`cs-${data.SEQ || data_index}-${data.CS_DATE}`">
              <!-- 20210607 홍현표수정-->
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="inquirer" :value="data.INQUIRER" @input="data.INQUIRER = $event" label="통화상대" placeholder="선택">
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item value="1" text="환자본인" />
                    <vs-select-item value="2" text="보호자" />
                    <vs-select-item value="3" text="보호자2" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="csMeberCode" :value="data.CS_MEMBER_CODE" @input="data.CS_MEMBER_CODE = $event" label="상담자" placeholder="선택">
                    <vs-select-item :value="item.CS_MEMBER_CODE" :text="item.CS_MEMBER" v-for="(item, index) in csMemberList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="csCateCode" :value="data.CS_CATE_CODE" @input="data.CS_CATE_CODE = $event" label="문의종류" placeholder="ex) 신규">
                    <vs-select-item value="" text="초기값" />
                    <vs-select-item :value="item.CS_CATE_CODE" :text="item.CS_CATE" v-for="(item, index) in csCateList" :key="index" />
                  </vs-select>
                </div>
              </div>
              <!-- <div class="vx-row mb-3">
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-input class="w-full" name="inquirer" v-model="data.INQUIRER" label="문의자" placeholder="ex) 홍길동" />
                        </div>
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-input class="w-full" name="phone" v-model="data.PHONE" label="연락처" placeholder="ex) 010-1234-5678" />
                        </div>
                        <div class="vx-col w-full lg:w-1/3">
                            <vs-input class="w-full" name="relation" v-model="data.RELATION" label="관계" placeholder="ex) 본인" />
                        </div>
                    </div> -->
              <div class="vx-row mb-3">
                <div class="vx-col w-full lg:w-1/3 ">
                  <vs-select autocomplete class="w-auto" name="csFavorCode" :value="data.CS_FAVOR_CODE" @input="data.CS_FAVOR_CODE = $event" label="다음일정 종류" placeholder="ex) 입원예약">
                    <vs-select-item value="0" text="초기값" />
                    <vs-select-item :value="item.CS_FAVOR_CODE" :text="item.CS_FAVOR" v-for="(item, index) in csFavorList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3" v-show="data.CS_FAVOR_CODE == 6 || data.CS_FAVOR_CODE == 7">
                  <vs-select autocomplete class="w-auto" name="csIssueCode" :value="data.CS_ISSUE_CODE" @input="data.CS_ISSUE_CODE = $event" label="부정이슈 종류" placeholder="ex) 비용">
                    <vs-select-item :value="item.CS_ISSUE_CODE" :text="item.CS_ISSUE" v-for="(item, index) in csIssueList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3" v-show="data.CS_ISSUE_CODE == 8">
                  <vs-input maxlength="15" class="w-full" name="issueText" :value="data.CS_ISSUE_TEXT" @input="data.CS_ISSUE_TEXT = $event" label="부정이슈직접입력" placeholder="ex) 부정이슈 입력" />
                </div>
                <div class="vx-col w-full lg:w-1/3" v-show="data.CS_FAVOR_CODE == 8">
                  <vs-select autocomplete class="w-auto" name="csIssueCode" :value="data.CS_ISSUE_CODE" @input="data.CS_ISSUE_CODE = $event" label="병실만실 세부" placeholder="">
                    <vs-select-item :value="item.CS_WARD_ID" :text="item.CS_WARD_NAME" v-for="(item, index) in csWardList" :key="index" />
                  </vs-select>
                </div>
                <div class="vx-col w-full lg:w-1/3" v-show="data.CS_FAVOR_CODE == 9">
                  <vs-select autocomplete class="w-auto" name="csIssueCode" :value="data.CS_ISSUE_CODE" @input="data.CS_ISSUE_CODE = $event" label="기타세부 사유" placeholder="">
                    <vs-select-item :value="item.CS_ETC_ID" :text="item.CS_ETC_NAME" v-for="(item, index) in csEtcList" :key="index" />
                  </vs-select>
                </div>
                <!-- <div class="vx-col w-full lg:w-1/3 " v-show="data.CS_FAVOR_CODE == 1 || data.CS_FAVOR_CODE == 3"> -->
                <div class="vx-col w-full lg:w-1/3 " v-show="data.CS_FAVOR_CODE == 1 || data.CS_FAVOR_CODE == 2 || data.CS_FAVOR_CODE == 3 || data.CS_FAVOR_CODE == 4">
                  <label for="" class="vs-input--label">
                    다음일정
                    <template v-if="data.CS_FAVOR_CODE == 1"> 입원상담 예정일</template>
                    <template v-if="data.CS_FAVOR_CODE == 2"> 방문예약 예정일</template>
                    <template v-if="data.CS_FAVOR_CODE == 3"> 리콜 예정일</template>
                    <template v-if="data.CS_FAVOR_CODE == 4"> 진료예약일</template>
                  </label>
                  <date-picker :id="'nextDate_' + data_index" :value="data.NEXT_DATE" @input="data.NEXT_DATE = $event" :locale="'ko'" valueType="format" class="vs-inputx normal w-full"></date-picker>
                </div>
                <div class="vx-col w-full lg:w-1/3" v-show="data.CS_FAVOR_CODE == 4">
                  <vs-select autocomplete class="w-auto" name="csIssueText" :value="data.CS_ISSUE_TEXT" @input="data.CS_ISSUE_TEXT = $event" label="진료원장님" placeholder="">
                    <vs-select-item :value="item.MEDICAL_NM" :text="item.MEDICAL_NM" v-for="(item, index) in doctorList" :key="index" />
                  </vs-select>
                </div>
              </div>

              <div class="vx-row">
                <div class="vx-col w-full">
                  <label for="" class="vs-input--label">상담내역</label>
                  <vs-textarea name="csContent" v-model="data.CS_CONTENT" @blur="data.CS_CONTENT = removeEscape(data.CS_CONTENT)"/>
                </div>
              </div>
              <div class="vx-row">
                <div class="vx-col w-full text-right">
                  <vs-button type="border" color="warning" @click="removeClickCs(data_index)"> (-)삭제 </vs-button>
                </div>
              </div>
              </vx-card>
              
              <!-- 무한 스크롤 로딩 인디케이터 -->
              <div v-if="hasMoreCsData && !isLoadingMore" ref="loadTrigger" class="text-center py-4">
                <vs-button @click="loadMoreCsDatas" type="line">
                  더 보기 ({{ remainingCsCount }}개 남음)
                </vs-button>
              </div>
              <div v-if="isLoadingMore" class="text-center py-4">
                <vs-spinner />
                <p>추가 상담내역 로딩 중...</p>
              </div>
            </div>
            
            <div class="vx-row">
              <div class="vx-col w-full text-center">
                <vs-button class="mb-1" color="success" v-show="displayedCsDatas.length > 0" @click="addClickCs">(+)추가</vs-button>
                <vs-button class="ml-3" @click="onClickModifyCs()" v-show="displayedCsDatas.length > 0">상담내역 저장</vs-button>
              </div>
            </div>
          </div>
        </div>
      </form>
    </vs-popup>
    <!--상담내역팝업끝-->
  </div>
</template>

<script>
import axiosClass from '../../util/axiosClass';
import { EventBus } from '../../util/vue-event-bus';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import Datepicker from 'vuejs-datepicker';
import vSelect from 'vue-select';
import { validationMobile } from '../../util/validation';
// TH 추가
import dateClass from '../../util/dateClass';
import store from '@/store/store';
import moment from "moment";
import $ from 'jquery';
import Vue from 'vue';
import kakaoWorkBot from '../../util/kakaoWorkAPI'
import axios from 'axios'
import { v4 as uuidv4 } from 'uuid';

export default {
  components: {
    DatePicker,
    Datepicker,
    'v-select': vSelect
  },
  data() {
    return {
      isSaving: false,
      addrOptions: [],
      openPopup: false,
      csPopup: false,
      popTabIdx: 1,
      tab_sum: store.getters.getTABSUM,
      userLevel: store.getters.getCDLEVEL,

      openPopup1: false,
      userUid: '',
      lists: [],
      page: 1,
      pageLimit: 15,
      totalCount: 0,
      pageCount: 0,
      listIndex: -1,
      patientUid: '',
      patientName: '',
      search: '',
      chartNo: '',
      chartNoReserved: false,      // 중복확인 완료 + 예약 성공
      chartNoDupWarning: false,    // PATIENT_MEMBER에 동일 차트번호 존재 (경고)
      chartNoChecking: false,      // 중복확인 API 호출 중
      patientUsername: '',
      sickNess: '',
      gisu: '',
      jumin: '',
      patientBirthday: '',
      patientGender: '',
      age: '',
      plan: '',
      newRe: '',
      cdStatus: '',
      initCdStatus: '',
      inInitDate: '',
      inDate: '',
      inTime: '',
      outTime: '',
      outDate: '',
      completeYn: 'N',
      mealTime: '',
      mealName: '',
      mealMemo: '',
      breakfast_mealName: '',
      lunch_mealName: '',
      dinner_mealName: '',
      medical_member_name: '',
      westMedicalNm: '',
      patientPhone: '',
      address: '',
      protectorPhone: '',
      protectorPhone2: '',
      protectorYN: '',
      medicalName: '',
      medicalNameText: '',
      memo: '',
      corona: '',
      medicalMemberList: [],
      medicalCenterList: [],
      insuranceCenterList: [],
      silbiJoinPeriodList: [],
      inLimitList: [],
      statusList: [],
      medicalRoomNumberListEtc: [],
      tab_menu: [],
      medical_room_seq: '',
      tb_menu: ['관리병동', '차트번호', '이름', '전화번호', '나이', '성별', '상태', '주치의', '관리'],
      searchStaus: '',
      kakaoPopup: false,
      kakao_date: dateClass.getDate('YYYY-MM-DD'),
      juminTF: false,
      medicalRoomList: [],
      medicalRoomNm: '',
      medicalRoomNumberList2: [],
      medicalRoomNumberNm: '',
      initMedicalRoomNumberNm: '',
      medicalRoomNumberNm_detail: '',
      medicalRoomNumberCntList: [],
      medicalRoomNumberCnt: '',
      initMedicalRoomNumberCnt: '',
      sickNessList: [],
      sickNessText: '',
      addressList: [],
      addressText: '',
      protectorList: [],
      protector: '',
      protector2: '',
      mealTimeList: [],
      mealNameList: [],
      mealMemoList: [],
      mealMemoText: '',
      coronaList: [],
      bodyPartList: [],
      anamnesisList: [],
      bodyPart: '',
      diagnosisDate: '',
      operationName: '',
      operationDate: '',
      metastasisYn: '',
      metastasisPart: '',
      anticancerDate: '',
      radiotherapyDate: '',
      antiagentYn: 'Y',
      antiagent: '',
      medication: '',
      anamnesisYn: 'N',
      anamnesis: [],
      anamnesisEtc: '',

      csPathList: [],
      csCateList: [],
      csMemberList: [],
      mainCsMemberList: [],
      csFavorList: [],
      csIssueList: [],
      csDatas: [],
      originalCsDatas: [],
      // 성능 개선을 위한 새로운 데이터 속성
      displayedCsDatas: [], // 실제 화면에 표시되는 상담내역
      csLoadCount: 10, // 한 번에 로드할 상담내역 수
      isLoadingMore: false, // 추가 로딩 중 상태
      
      // 상담내역 편집을 위한 평면화된 상태
      csEditingStates: {}, // { index: { inquirer: '', csMemberCode: '', ... } }
      csEditModes: {}, // { index: false/true }
      nutritionMemo: '',
      expire: false,
      width: window.innerWidth,
      cdStatusChange_YN: '',
      kakao_sender: 1,
      csRel: ['환자본인', '보호자1', '보호자2'],
      etcMemo: '',
      roomMemo: '',
      csMemo: '',
      cs2Memo: '',
      cs3Memo: '',
      moduleRoomlist: [],
      tabArray_01: [],
      mainCs: '',
      mainCsCaller: '1',
      mainCsCallerPhone: '',
      initPath: '',
      patientPosition: 1,
      issueText: '',
      classInfo: 1,

      // 230413 TH 추가
      nextCD : '',
      options : [],
      disabledDate : true,
      selectedMedicalCodeCs : {},
      medicalManagers :'',
      dc_memoCs : '',
      viewManagerList : [],
      viewDetailList: [],
      managerList: [],
      medicalDetails: [],
      select_user : '',
      tab_options : [],
      dcCs: false,
      cure_data : [],
      date_list: [],
      cure_count : [],
      tab_all_tf: false,
      medicalCode : '',
      scheduleSelectDateCs : '',
      scheduleSelectTimeCs : '',
      selectedMedicalCodeCs : '',
      scheduleMemoCs: '',
      patientId: '',
      patientList: [],
      schedulePopupTitle: '',
      patientUserInfo : '',
      schedule_gubun: '',
      gubun_list: [
        { VALUE: '1', TEXT: '초진' },
        { VALUE: '2', TEXT: '재진' },
        { VALUE: '3', TEXT: '신입진료' },
        { VALUE: '4', TEXT: '재입진료' },
        { VALUE: '5', TEXT: '입원중진료' },
        { VALUE: '97', TEXT: '휴진' },
        { VALUE: '98', TEXT: '외래' },
        { VALUE: '99', TEXT: '기타' },
      ],
      autoCheck: null,
      schdule_endYN: 'N',
      schedule_end: '',
      schedule_week: [],
      schedule_gubun_type: 0,
      schedule_gubun_number: 1,
      schedule_gubun_days: 0,

      insuranceChk: false,
      insuranceName: "",
      silbiJoinPeriod: "",
      insuranceNameText: "",
      inLimit: "",
      inLimitText: "",
      inGuarantee: "",
      balance: "",
      confirmDate: dateClass.getDate("YYYY-MM-DD"),
      outpatDayLimit: "",
      outpatDayLimitText: "",
      outPatCount: "",
      indemStdt: "" ,
      indemEnddt: "" ,
      joinDate: "",
      memo: "",
      csAddYN: 'N',
      etcSchedule: false,
      followUpDate: '',
      inspectionDate: '',
      consultDoctorUid: '',
      csWardList: [],
      csEtcList: [],
      doctorList: [],
      wantedRoom1: '',
      wantedRoom2: '',
      wantedRoom3: '',
      oxygenPoint: 0 ,
      showOxygenCard : false,
      adjustedOxygenPoint : 0,
      inFlowList : [],
      inFlowPath : '',
    };
  },
  computed: {
    hasMoreCsData() {
      return this.displayedCsDatas.length < this.csDatas.length;
    },
    remainingCsCount() {
      return this.csDatas.length - this.displayedCsDatas.length;
    }
  },
  methods: {
    // 상담내역 편집 상태 관리 메서드
    getEditingValue(index, field, defaultValue) {
      if (!this.csEditingStates[index]) {
        return defaultValue;
      }
      return this.csEditingStates[index][field] !== undefined 
        ? this.csEditingStates[index][field] 
        : defaultValue;
    },
    
    updateEditingValue(index, field, value) {
      if (!this.csEditingStates[index]) {
        this.$set(this.csEditingStates, index, {});
      }
      this.$set(this.csEditingStates[index], field, value);
    },

    initializeEditingState(index, csData) {
      this.$set(this.csEditingStates, index, {
        INQUIRER: csData.INQUIRER || '',
        CS_MEMBER_CODE: csData.CS_MEMBER_CODE || '',
        CS_CATE_CODE: csData.CS_CATE_CODE || '',
        CS_FAVOR_CODE: csData.CS_FAVOR_CODE || '',
        CS_ISSUE_CODE: csData.CS_ISSUE_CODE || '',
        CS_ISSUE_TEXT: csData.CS_ISSUE_TEXT || '',
        NEXT_DATE: csData.NEXT_DATE || '',
        CS_CONTENT: csData.CS_CONTENT || ''
      });
    },

    getUpdatedCsData(index, originalData) {
      const editingState = this.csEditingStates[index];
      if (!editingState) {
        return originalData;
      }
      
      return {
        ...originalData,
        INQUIRER: editingState.INQUIRER !== undefined ? editingState.INQUIRER : originalData.INQUIRER,
        CS_MEMBER_CODE: editingState.CS_MEMBER_CODE !== undefined ? editingState.CS_MEMBER_CODE : originalData.CS_MEMBER_CODE,
        CS_CATE_CODE: editingState.CS_CATE_CODE !== undefined ? editingState.CS_CATE_CODE : originalData.CS_CATE_CODE,
        CS_FAVOR_CODE: editingState.CS_FAVOR_CODE !== undefined ? editingState.CS_FAVOR_CODE : originalData.CS_FAVOR_CODE,
        CS_ISSUE_CODE: editingState.CS_ISSUE_CODE !== undefined ? editingState.CS_ISSUE_CODE : originalData.CS_ISSUE_CODE,
        CS_ISSUE_TEXT: editingState.CS_ISSUE_TEXT !== undefined ? editingState.CS_ISSUE_TEXT : originalData.CS_ISSUE_TEXT,
        NEXT_DATE: editingState.NEXT_DATE !== undefined ? editingState.NEXT_DATE : originalData.NEXT_DATE,
        CS_CONTENT: editingState.CS_CONTENT !== undefined ? editingState.CS_CONTENT : originalData.CS_CONTENT
      };
    },

    handleContentBlur(index, event) {
      const cleanedContent = this.removeEscape(event.target.value);
      this.updateEditingValue(index, 'CS_CONTENT', cleanedContent);
    },
    async init() {
      try {
        this.userUid = store.getters.getUID;
        //console.log(store.getters.getUID);
        //console.log(store.getters.getMemberEmail);
        this.csDatas = [];
        let params = {
          userUid: this.userUid,
          patientId: this.uid
        };

        const { data } = await axiosClass.get('/api/patient/list', params, true);
        
        this.moduleRoomlist = data.roomlist;
        this.medicalMemberList = data.medicalMemberList;
        this.medicalCenterList = data.medicalCenterList;
        this.insuranceCenterList = data.insuranceCenterList;
        this.silbiJoinPeriodList = data.silbiJoinPeriodList;
        this.sickNessList = data.sickNessList;
        this.addressList = data.addressList;
        this.protectorList = data.protectorList;
        this.mealTimeList = data.mealTimeList;
        this.statusList = data.statusList;

        this.mealNameList = data.mealNameList;
        this.mealMemoList = data.mealMemoList;
        this.coronaList = data.coronaList;
        this.inFlowList = data.inFlowList;
        console.log(this.inFlowList)
        if (this.addrOptions.length == 0) {
          let addrOptions_Obj = {};
          addrOptions_Obj.group = [];
          for (let i = 0; i < data.addressList.length; i++) {
            const obj = data.addressList[i];
            const _do = obj.DO;
            const _bf_do = i > 0 ? data.addressList[i - 1].DO : '';
            const _si = obj.SI;
            const groupObj = { text: _si, value: _si };
            if (_do != _bf_do) {
              if (i > 0) {
                this.addrOptions.push(addrOptions_Obj);
              }
              addrOptions_Obj = {};
              addrOptions_Obj.group = [];
              addrOptions_Obj.title = _do;
            } else {
              if (data.addressList.length == i + 1) {
                this.addrOptions.push(addrOptions_Obj);
              }
            }
            addrOptions_Obj.group.push(groupObj);
          }
        }

        this.statusList = data.statusList;
        this.medicalRoomNumberListEtc = data.medicalRoomNumberListEtc;
        this.medicalRoomList = data.medicalRoomList;
        this.bodyPartList = data.bodyPartList;
        this.anamnesisList = data.anamnesisList;
        this.csPathList = data.csPathList;
        this.csCateList = data.csCateList;
        this.csMemberList = data.csMemberList;
        this.mainCsMemberList = data.mainCsMemberList;
        this.csFavorList = data.csFavorList;
        this.csIssueList = data.csIssueList;
        this.csWardList = data.csWardList;
        this.csEtcList = data.csEtcList;
        this.doctorList = data.doctorList;
        this.showOxygenCard = false;
        this.adjustedOxygenPoint = 0;
        setTimeout(() => {
          this.$vs.loading.close('#list > .con-vs-loading');
        }, 100);
      } catch (e) {
        console.log(e.response.data);
      }
    },

    //입원예정일 입력 시 시간 초기화 + 입원예정시간, 식사구분, 입원일 식이, 입원일 식이 비고, 코로나검사여부
    inTimeReset() {
      this.inTime = '';
      this.mealTime = '';
      this.mealName = '';
      this.mealMemo = '';
      this.corona = '';
    },

    // 차트번호 예약 해제 (폼 닫기 / 저장 완료 후 호출)
    async releaseChartNoReservation() {
      if (this.chartNoReserved && this.chartNo && this.patientUid) {
        try {
          await axiosClass.delete('/api/patient/reserveChartNo', { chartNo: this.chartNo, patientUid: this.patientUid }, true);
        } catch (e) {
          // 해제 실패는 무시 (서버 TTL 5분 스케줄러가 정리)
        }
      }
      this.chartNoReserved = false;
      this.chartNoDupWarning = false;
      this.chartNoChecking = false;
    },

    // 신규 환자 등록 시 폼 데이터 초기화
    resetFormData() {
      this.releaseChartNoReservation();
      this.popTabIdx = 1;
      this.patientUid = uuidv4();
      this.chartNo = '';
      this.patientUsername = '';
      this.sickNess = '';
      this.sickNessText = '';
      this.gisu = '';
      this.jumin = '';
      this.patientBirthday = '';
      this.patientGender = '';
      this.age = '';
      this.plan = '';
      this.newRe = '신입';
      this.cdStatus = '';
      this.initCdStatus = '';
      this.inInitDate = '';
      this.inDate = '';
      this.inTime = '';
      this.outTime = '';
      this.outDate = '';
      this.completeYn = 'N';
      this.mealTime = '';
      this.mealName = '';
      this.mealMemo = '';
      this.breakfast_mealName = '';
      this.lunch_mealName = '';
      this.dinner_mealName = '';
      this.medical_member_name = '';
      this.westMedicalNm = '';
      this.patientPhone = '';
      this.address = '';
      this.protectorPhone = '';
      this.protectorPhone2 = '';
      this.protectorYN = 'N';
      this.protector = '';
      this.protector2 = '';
      this.medicalName = '';
      this.medicalNameText = '';
      this.insuranceChk = false;
      this.insuranceName = '';
      this.insuranceNameText = '';
      this.silbiJoinPeriod = '';
      this.inLimit = '';
      this.inLimitText = '';
      this.inGuarantee = '';
      this.balance = '';
      this.confirmDate = '';
      this.outpatDayLimit = '';
      this.outpatDayLimitText = '';
      this.outPatCount = '';
      this.indemStdt = '';
      this.indemEnddt = '';
      this.joinDate = '';
      this.memo = '';
      this.corona = '';
      this.bodyPart = '';
      this.diagnosisDate = '';
      this.operationDate = '';
      this.operationName = '';
      this.metastasisYn = '';
      this.metastasisPart = '';
      this.anticancerDate = '';
      this.radiotherapyDate = '';
      this.antiagentYn = 'Y';
      this.antiagent = '';
      this.medication = '';
      this.anamnesisYn = 'N';
      this.anamnesis = [];
      this.anamnesisEtc = '';
      this.nutritionMemo = '';
      this.kakao_sender = '';
      this.medicalRoomCd = '';
      this.medicalRoomNumberCd = '';
      this.medicalRoomNumberNm = '';
      this.initMedicalRoomNumberNm = '';
      this.initMedicalRoomNumberCnt = '';
      this.initPath = '';
      this.inFlow = '';
      this.inFlowText = '';
      this.mainCs = '';
      this.consultDoctorUid = '';
      this.showOxygenCard = false;
      this.adjustedOxygenPoint = 0;
      this.csDatas = [];
      this.originalCsDatas = [];
      this.displayedCsDatas = [];
      console.log('[MemerView] Form data reset for new patient, patientUid:', this.patientUid);
    },

    async popTabClick(popTabIdx) {
      // console.log('this.patientUid:::', this.patientUid);
      let checkedTF = false;

      this.$vs.loading();

      if (popTabIdx == 2) {
        // if (this.patientUid == '') {
        //     checkedTF = await this.onClickModify('t');
        //     if (!checkedTF) {
        //         return;
        //     }
        // }
        await this.onClickCs();
      }

      await this.memberSelect();
      this.popTabIdx = popTabIdx;

      setTimeout(() => {
        this.$vs.loading.close();
        if (popTabIdx == 2) {
          this.openPopup = false;
          this.csPopup = true;
        } else {
          this.openPopup = true;
          this.csPopup = false;
        }
      }, 1000);
    },
    anamnesisInput() {
      this.anamnesisEtc = this.anamnesis.indexOf('기타') < 0 ? '' : this.anamnesisEtc;
    },
    async onClickCs() {
      console.log('[onClickCs] Called with this.uid:', this.uid);
      this.csDatas = [];
      this.originalCsDatas = [];
      this.displayedCsDatas = [];
      let params = {
        patientUid: this.uid,
      };
      console.log('[onClickCs] Calling API: /api/patient/cs/' + this.uid);

      let data;
      try {
        const response = await axiosClass.get('/api/patient/cs/' + this.uid, params, true);
        data = response.data;
        console.log('[onClickCs] API response csDatas length:', data.csDatas ? data.csDatas.length : 0);
      } catch (error) {
        console.error('[onClickCs] 로드 실패:', error);
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: '상담 정보를 불러오는 중 오류가 발생했습니다.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        // Set empty state so UI doesn't break
        this.csDatas = [];
        this.originalCsDatas = [];
        this.displayedCsDatas = [];
        return;
      }

      //console.log(data);
      const dataLengthCheck = data.memberData ? Object.keys(data.memberData).length : 0;
      // console.log('data:' + data);
      if (data.csDatas && data.csDatas.length > 0) {
        this.csDatas = data.csDatas;
        this.originalCsDatas = JSON.parse(JSON.stringify(this.csDatas));
        // 초기 표시 데이터 설정 (처음 10개만)
        this.initializeDisplayedData();
        console.log('[onClickCs] After initializeDisplayedData:', {
          csDatas_length: this.csDatas.length,
          displayedCsDatas_length: this.displayedCsDatas.length,
          displayedCsDatas: this.displayedCsDatas
        });
      } else {
        // csDatas가 없거나 빈 배열인 경우에도 빈 배열로 초기화
        this.csDatas = [];
        this.originalCsDatas = [];
        this.displayedCsDatas = [];
        console.log('[onClickCs] No CS data received');
      }

      // patientUid를 uid로 설정 (중요!)
      // 새 환자인 경우 UUID 생성
      this.patientUid = this.uid || (dataLengthCheck == 0 ? uuidv4() : (data.memberData && data.memberData.PATIENT_UID ? data.memberData.PATIENT_UID : uuidv4()));
      this.chartNo = dataLengthCheck == 0 ? this.chartNo : (data.memberData && data.memberData.CHART_NO ? data.memberData.CHART_NO : this.chartNo);
      this.patientUsername = dataLengthCheck == 0 ? this.patientUsername : (data.memberData && data.memberData.PATIENT_USERNAME ? data.memberData.PATIENT_USERNAME : this.patientUsername);
      this.patientGender = dataLengthCheck == 0 ? this.patientGender : (data.memberData && data.memberData.PATIENT_GENDER ? data.memberData.PATIENT_GENDER : this.patientGender);
      this.patientPhone = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.PATIENT_PHONE ? data.memberData.PATIENT_PHONE : "");
      this.medicalName = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.MEDICAL_NAME ? data.memberData.MEDICAL_NAME : "");
      this.age = dataLengthCheck == 0 ? this.age : (data.memberData && data.memberData.PATIENT_AGE ? data.memberData.PATIENT_AGE : this.age);
      this.corona = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.CORONA ? data.memberData.CORONA : "");
      this.inFlowPath = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.INFLOW ? data.memberData.INFLOW : "");
      this.mainCs = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.MAIN_CS_UID ? data.memberData.MAIN_CS_UID : "");
      this.mainCsCallerPhone = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.MAIN_CS_CALLER ? data.memberData.MAIN_CS_CALLER : "");
      this.initPath = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.INITPATH ? data.memberData.INITPATH : "");
      this.patientPosition = dataLengthCheck == 0 ? 1 : (data.memberData && data.memberData.PATIENT_POSITION ? data.memberData.PATIENT_POSITION : 1);
      this.protectorPhone = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.PROTECTOR_PHONE ? data.memberData.PROTECTOR_PHONE : "");
      this.protectorPhone2 = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.PROTECTOR_PHONE2 ? data.memberData.PROTECTOR_PHONE2 : "");
      this.protectorYN = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.PROTECTOR_YN ? data.memberData.PROTECTOR_YN : "");
      this.protector = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.PROTECTOR ? data.memberData.PROTECTOR : "");
      this.protector2 = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.PROTECTOR2 ? data.memberData.PROTECTOR2 : "");
      this.sickNess = dataLengthCheck == 0 ? this.sickNess : (data.memberData && data.memberData.SICKNESS ? data.memberData.SICKNESS : this.sickNess);
      this.bodyPart = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.BODYPART ? data.memberData.BODYPART : "");
      this.gisu = dataLengthCheck == 0 ? this.gisu : (data.memberData && data.memberData.GISU ? data.memberData.GISU : this.gisu);
      this.diagnosisDate = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.DIAGNOSIS_DATE ? data.memberData.DIAGNOSIS_DATE : "");
      this.operationName = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.OPERATION_NAME ? data.memberData.OPERATION_NAME : "");
      this.operationDate = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.OPERATION_DATE ? data.memberData.OPERATION_DATE : "");
      this.metastasisYn = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.METASTASIS_YN ? data.memberData.METASTASIS_YN : "");
      this.metastasisPart = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.METASTASIS_PART ? data.memberData.METASTASIS_PART : "");
      this.anticancerDate = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.ANTICANCER_DATE ? data.memberData.ANTICANCER_DATE : "");
      this.radiotherapyDate = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.RADIOTHERAPY_DATE ? data.memberData.RADIOTHERAPY_DATE : "");
      this.antiagentYn = 'Y'; //data.memberData.ANTIAGENT_YN;
      this.antiagent = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.ANTIAGENT ? data.memberData.ANTIAGENT : "");
      this.medication = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.MEDICATION ? data.memberData.MEDICATION : "");
      this.anamnesisYn = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.ANAMNESIS_YN ? data.memberData.ANAMNESIS_YN : "");

      this.etcMemo = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.ETC_MEMO ? data.memberData.ETC_MEMO : "");
      this.roomMemo = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.ROOM_MEMO ? data.memberData.ROOM_MEMO : "");
      this.csMemo = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.CS_MEMO ? data.memberData.CS_MEMO : "");
      this.cs2Memo = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.CS2_MEMO ? data.memberData.CS2_MEMO : "");
      this.cs3Memo = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.CS3_MEMO ? data.memberData.CS3_MEMO : "");
      this.nutritionMemo = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.NUTRITION_MEMO ? data.memberData.NUTRITION_MEMO : "");
      this.memo = dataLengthCheck == 0 ? "" : (data.memberData && data.memberData.NUTRITION_MEMO ? data.memberData.NUTRITION_MEMO : "")

      this.csPathList = dataLengthCheck == 0 || !data || !data.csPathList ? this.csPathList : data.csPathList;
      this.csCateList = dataLengthCheck == 0 || !data || !data.csCateList ? this.csCateList : data.csCateList;
      this.csMemberList = dataLengthCheck == 0 || !data || !data.csMemberList ? this.csMemberList : data.csMemberList;
      this.csFavorList = dataLengthCheck == 0 || !data || !data.csFavorList ? this.csFavorList : data.csFavorList;
      this.csIssueList = dataLengthCheck == 0 || !data || !data.csIssueList ? this.csIssueList : data.csIssueList;
      this.csWardList = dataLengthCheck == 0 || !data || !data.csWardList ? this.csWardList : data.csWardList;
      this.csEtcList = dataLengthCheck == 0 || !data || !data.csEtcList ? this.csEtcList : data.csEtcList;
      this.doctorList = dataLengthCheck == 0 || !data || !data.doctorList ? this.doctorList : data.doctorList;
      this.moduleRoomlist = dataLengthCheck == 0 || !data || !data.roomlist ? this.moduleRoomlist : data.roomlist;

      this.protectorList = dataLengthCheck == 0 || !data || !data.protectorList ? this.protectorList : data.protectorList;
      this.mainCsMemberList = dataLengthCheck == 0 || !data || !data.mainCsMemberList ? this.mainCsMemberList : data.mainCsMemberList;
      this.medicalCenterList = dataLengthCheck == 0 || !data || !data.medicalCenterList ? this.medicalCenterList : data.medicalCenterList;
      this.bodyPartList = dataLengthCheck == 0 || !data || !data.bodyPartList ? this.bodyPartList : data.bodyPartList;

      this.sickNessList = dataLengthCheck == 0 || !data || !data.sickNessList ? this.sickNessList : data.sickNessList;
      this.csAddYN = 'N';
      this.followUpDate = data.memberData && data.memberData.FOLLOWUP_DATE ? data.memberData.FOLLOWUP_DATE : '';
      this.inspectionDate = data.memberData && data.memberData.INSPECTION_DATE ? data.memberData.INSPECTION_DATE : '';

      if (this.followUpDate == '' && this.inspectionDate == '') {
        this.etcSchedule = false;
      } else {
        this.etcSchedule = true;
      }
      await this.getTabList();
    },

    activeMenu2(popTabIdx) {
      if (popTabIdx == this.popTabIdx) {
        return 'activeMenu2';
      } else {
        return '';
      }
    },
    // 20230413 TH 추가
    cdStatusChange() {
      //console.info("cdStatusChange");
      if (this.cdStatus != "9" && this.cdStatus != "14") {
        this.medicalRoomNm = "";
        this.medicalRoomNumberNm = "";
        this.medicalRoomNumberCnt = "";
        this.medicalRoomNumberList2 = [];
        this.medicalRoomNumberCntList = [];
      }
      this.cdStatusChange_YN = "Y";

      //console.info("cdStatusChange_YN:" + this.cdStatusChange_YN);
    },
    // 20230413 TH 추가
    dateInit(){
      this.inDate = null;
      this.outDate = null;
    },
    dateStatusChange() {
      this.cdStatusChange_YN = "N";
    },
    //현재상태 및 신입재입 체크
    statusCheck(completeYn, inInitDate, inDate, outDate) {
      completeYn = completeYn || 'N';

      inInitDate = inInitDate || '';
      inDate = inDate || '';
      outDate = outDate || '';
      let now_status = this.cdStatus;

      let diff = dateClass.dateDiff(outDate, inDate);

      this.now_day = dateClass.getDate('YYYY-MM-DD');
      //console.log('now_status:' + now_status);
      let check = this.cdStatusChange_YN;

      if (check == "Y" && this.cdStatus == "14") {
        //console.info("수동 또는 입원대기");
        return
      }

      //console.info("자동");
      if (completeYn == "Y") {
        // 현재 상태 : 완퇴
        //console.info("완퇴");
        this.cdStatus = "10";
        this.medicalRoomNumberNm = "완퇴";
      } else {
        // 현재 상태
        // if (this.cdStatus == '14') {
        //     // 입원대기
        //     this.cdStatus = '14';
        //     console.log('cdstatus:' + this.cdStatus);

        //     this.medicalRoomNm = '';
        //     this.medicalRoomNumberNm = '';
        //     this.medicalRoomNumberCnt = '';
        // }

        if (inInitDate == "") {
          // 외래
          //console.info("외래 : inInitDate no data");
          this.cdStatus = "8";
          this.medicalRoomNm = "";
          // this.medicalRoomNumberNm = '';
          this.medicalRoomNumberCnt = "";
        } else if (outDate == this.now_day) {
          // 퇴원일
          //console.info("퇴원일");
          this.cdStatus = "12";

          if (now_status == 7) {
            this.medicalRoomNm = "";
            this.medicalRoomNumberNm = "";
            this.medicalRoomNumberCnt = "";
          }
        } else if (inDate < this.now_day) {
          // if (diff >= 0 && diff < 6 && inDate < outDate) {
          //     // 가퇴원
          //     this.cdStatus = '13';
          // } else
          if (outDate < this.now_day && inDate <= outDate) {
            // 퇴원
            //console.info("퇴원");
            this.cdStatus = "7";
            this.medicalRoomNm = "";
            this.medicalRoomNumberCnt = "";
            this.medicalRoomNumberNm = "퇴원";
            // } else if(inDate < this.now_day && this.now_day < outDate) {
          } else {
            // 입원
            //console.info("입원");
            this.cdStatus = "6";

            if (now_status != 6 && now_status != 11 && now_status != 12 && now_status != 13) {
              this.medicalRoomNm = "";
              this.medicalRoomNumberNm = "";
              this.medicalRoomNumberCnt = "";
            }
          }
        } else if (inDate == this.now_day) {
          // 입원일
          //console.info("입원일");
          this.cdStatus = "11";
          if (now_status != 6) {
          }
        } else if (inDate > this.now_day) {
          if (diff >= 0 && diff < 4 && outDate <= this.now_day) {
            // 가퇴원
            //console.info("가퇴원");
            this.cdStatus = "13";
          } else if (outDate < this.now_day) {
            // 입원예정
            //console.info("입원예정");
            this.cdStatus = "9";
          } else if (outDate >= inDate) {
            // 입원예정
            //console.info("입원예정");
            this.cdStatus = "9";
          } else {
            // 입원
            //console.info("입원");
            this.cdStatus = "6";
          }
        }
        // } else if (inDate > this.now_day) {
        //   if (outDate < this.now_day) {
        //     if(diff >= 0 && diff < 4) {
        //       // 가퇴원
        //       console.info("가퇴원");
        //       this.cdStatus = "13";
        //     }
        //   } else if (this.now_day < inDate) {
        //     // 입원예정
        //     console.info("입원예정");
        //     this.cdStatus = "9";
        //   } else if (outDate >= inDate) {
        //     // 입원예정
        //     console.info("입원예정");
        //     this.cdStatus = "9";
        //   } else {
        //     // 입원
        //     console.info("입원");
        //     this.cdStatus = "6";
        //   }
        // }
      }

      // 신입재입 체크
      if (now_status == 6 && (inInitDate == '' || inDate == '')) {
        this.newRe = '오류';
      } else if (inDate > inInitDate && inInitDate != '' && inDate != '') {
        this.newRe = '재입';
      } else if (inDate == inInitDate && inInitDate != '' && inDate != '') {
        this.newRe = '신입';
      } else {
        this.newRe = '신입';
      }
    },
    mainCsCallerChange(mainCsCallerValue) {
      if (mainCsCallerValue == 1) {
        if (this.patientPhone == '') {
          this.patientPhone = this.mainCsCallerPhone;
        } else {
          this.mainCsCallerPhone = this.patientPhone;
        }
      } else if (mainCsCallerValue == 2) {
        if (this.protectorPhone == '') {
          this.protectorPhone = this.mainCsCallerPhone;
        } else {
          this.mainCsCallerPhone = this.protectorPhone;
        }
        // this.mainCsCallerPhone = this.protectorPhone;
      } else if (mainCsCallerValue == 3) {
        if (this.protectorPhone2 == '') {
          this.protectorPhone2 = this.mainCsCallerPhone;
        } else {
          this.mainCsCallerPhone = this.protectorPhone2;
        }
        // this.mainCsCallerPhone = this.protectorPhone2;
      }
    },
    //병동선택 change
    async medicalRoomChange(first = 'N') {
      let params = {
        medicalRoomNm: this.medicalRoomNm,
      };
      const { data } = await axiosClass.get('/api/patient/medicalRoomNumberList2', params, true);
      this.medicalRoomNumberList2 = data.medicalRoomNumberList2;

      if (first == 'N') {
        this.medicalRoomNumberNm = '';
        this.medicalRoomNumberCntList = [];
        this.medicalRoomNumberCnt = '';
      }
    },

    //병실선택 change
    async medicalRoomNumberChange(first = 'N') {
      let params = {
        medicalRoomNumberNm: this.medicalRoomNumberNm,
      };

      const { data } = await axiosClass.get('/api/patient/medicalRoomNumberCntList', params, true);

      this.medicalRoomNumberCntList = data.medicalRoomNumberCntList;
      if (first == 'N') {
        this.medicalRoomNumberCnt = '';
      }
    },
    // 230330 TH 추가
    // 주민번호에 - 추가
    juminAddString(jumin) {
      if(event.keyCode === 8) {
        return false
      } else if((event.keyCode === 109) || (event.keyCode === 189)) {
        event.preventDefault();
      } else if (jumin.length == 7) {

        const jumin_fore = jumin.substr(0,6) || "";
        const jumin_post = jumin.substr(6,7) || "";
        let juminString = '';
        this.jumin = jumin_fore + '-' + jumin_post;
      }
    },
    juminCheck() {
      let err_msg = '';
      const jumin_1 = this.jumin.split('-')[0] || '';
      const jumin_2 = this.jumin.split('-')[1] || '';

      const patientGenderCode = jumin_2 != undefined && jumin_2.length > 0 ? jumin_2.substr(0, 1) : '';
      const genderCode_2000_Array = ['3', '4', '7', '8'];
      const genderCode_1900_Array = ['1', '2', '5', '6'];
      const genderCode_1800_Array = ['9', '0'];
      const today = dateClass.getDate('YYYYMMDD');
      const today_Y = dateClass.getDate('YYYY');
      const jumin_1_2000 = '20' + jumin_1;
      if (
          this.jumin.indexOf('-') < 0 ||
          this.jumin.length != 14 ||
          (this.jumin.match(/-/g) != null && this.jumin.match(/-/g).length != 1) ||
          isNaN(jumin_1) ||
          // isNaN(jumin_2) ||
          jumin_1.length != 6 ||
          jumin_2.length != 7 ||
          patientGenderCode == ''
      ) {
        err_msg = '주민번호를 [123456-1234567]형태로 올바르게 입력하여 주십시오.';
      } else {
        if (isNaN(patientGenderCode)) {
          err_msg = '주민번호 성별을 올바르게 입력하여 주십시오.';
        } else if (genderCode_2000_Array.indexOf(patientGenderCode) > -1 && today < jumin_1_2000) {
          err_msg = '2000년대의 생년월일을 확인하여 주십시오.';
        }
      }
      if (err_msg != '') {
        if (this.csPopup == false) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: err_msg,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          this.juminTF = false;
          return;
        }
      } else {
        this.patientGender = patientGenderCode % 2 == 0 ? 'F' : 'M';
        let patientBirth_MD = jumin_1.substr(2, 2) + '-' + jumin_1.substr(4, 2);
        let patientBirth_Y = jumin_1.substr(0, 2);
        if (genderCode_2000_Array.indexOf(patientGenderCode) > -1) {
          patientBirth_Y = '20' + patientBirth_Y;
        } else if (genderCode_1900_Array.indexOf(patientGenderCode) > -1) {
          patientBirth_Y = '19' + patientBirth_Y;
        } else if (genderCode_1800_Array.indexOf(patientGenderCode) > -1) {
          patientBirth_Y = '18' + patientBirth_Y;
        }
        this.patientBirthday = patientBirth_Y + "-" + patientBirth_MD;

        if (this.patientBirthday != "") {
          // this.age = today_Y - patientBirth_Y + 1;

          // 230329 TH 새로운 나이 구하는 식
          let realAge = '';
          const todayNew = new Date();
          // 년 월 일 분리
          const birthDate = new Date(patientBirth_Y, jumin_1.substr(2, 2), jumin_1.substr(4, 2));

          realAge = todayNew.getFullYear() - birthDate.getFullYear();

          const monthDiff = todayNew.getMonth() - (birthDate.getMonth()-1);
          if(monthDiff < 0 || (monthDiff == 0 && todayNew.getDate() < birthDate.getDate())) {
            realAge--;
          }

          this.age = realAge
        }

        this.juminTF = true;
      }
    },

    //환자 추가 및 수정 팝업닫기
    onClickModifyHide() {
      this.openPopup = !this.openPopup;
    },
    //환자 추가 및 수정 처리
    async onClickModify(type) {
      if (type == 'b') {
        if (this.inInitDate != '') {
          if (this.inDate == '') {
            let err_msg = '';
            err_msg = '최초입원일이 입력되어 입원일은 필수 입력입니다.';
            if (err_msg != '') {
              this.$vs.notify({
                color: 'danger',
                title: 'Error',
                text: err_msg,
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
              });
              return;
            }
          }
        }
      }
      if (type != 'cs') {
        if (this.jumin != '') {
          this.juminCheck();
          if (!this.juminTF) return;
        }

        // this.statusCheck(this.completeYn, this.inInitDate, this.inDate, this.outDate);
        if (this.cdStatus != 9) {
          let checked = false;
          if (this.cdStatus < 11) {
            let err_msg = '';
            if (this.cdStatus == 6) {
              if (this.medicalRoomNumberCnt == '') {
                err_msg = '입원의 경우 베드위치는 필수 선택입니다.';
              }
            }
            if (err_msg != '') {
              this.$vs.notify({
                color: 'danger',
                title: 'Error',
                text: err_msg,
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-alert-circle',
              });
              return;
            }
          }
        }
      }
      if (this.patientUsername == '') {
        let err_msg = '';
        err_msg = '이름을 입력해주세요.';
        if (err_msg != '') {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: err_msg,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return;
        }
      }

      let err_msg = '';
      let objName = '';

      const medicalName = this.medicalName == '직접입력' ? this.medicalNameText : this.medicalName;
      const insuranceName = this.insuranceName == "직접입력" ? this.insuranceNameText : this.insuranceName;
      const sickNess = this.sickNess == '직접입력' ? this.sickNessText : this.sickNess;
      const mealMemo = this.mealMemo == '직접입력' ? this.mealMemoText : this.mealMemo;

      if (this.age > 100) {
        this.age = 0;
      }

      let anamnesis = '';
      for (let i = 0; i < this.anamnesis.length; i++) {
        let anamnesisText = this.anamnesis[i];
        if (anamnesis != '') anamnesisText = ',' + anamnesisText;
        anamnesis += anamnesisText;
      }
      const tabSum_01 = this.tabArray_01.reduce(function add(sum, currValue) {
        return sum + currValue;
      }, 0);
      let expireYN = this.expire == true ? 'Y' : 'N';
      let params = {
        patientUid: this.patientUid,
        chartNo: this.chartNo,
        patientUsername: this.patientUsername,
        sickNess: sickNess,
        gisu: this.gisu,
        jumin: this.jumin,
        patientBirthday: this.patientBirthday,
        patientGender: this.patientGender,
        age: this.age,
        plan: this.plan,
        expire: expireYN,
        classInfo : this.classInfo,
        newRe: this.newRe,
        cdStatus: this.cdStatus,
        initCdStatus: this.initCdStatus,
        inInitDate: this.inInitDate,
        inDate: this.inDate,
        inTime: this.inTime,
        outTime: this.outTime,
        outDate: this.outDate,
        completeYn: this.completeYn,
        mealTime: this.mealTime,
        mealName: this.mealName,
        mealMemo: mealMemo,
        breakfast_mealName: this.breakfast_mealName,
        lunch_mealName: this.lunch_mealName,
        dinner_mealName: this.dinner_mealName,
        medical_member_name: this.medical_member_name,
        westMedicalNm: this.westMedicalNm,
        patientPhone: this.patientPhone,
        address: this.address,
        protectorPhone: this.protectorPhone,
        protectorPhone2: this.protectorPhone2,
        protectorYN: this.protectorYN,
        protector: this.protector,
        protector2: this.protector2,
        medicalName: medicalName,
        insuranceName: insuranceName,
        silbiJoinPeriod: this.silbiJoinPeriod,
        memo: this.memo,
        corona: this.corona,
        inFlow: this.inFlowPath,
        medicalRoomNumberNm: this.medicalRoomNumberNm,
        medicalRoomNumberCnt: this.medicalRoomNumberCnt,
        initMedicalRoomNumberNm: this.initMedicalRoomNumberNm,
        initMedicalRoomNumberCnt: this.initMedicalRoomNumberCnt,
        bodyPart: this.bodyPart,
        diagnosisDate: this.diagnosisDate,
        operationName: this.operationName,
        operationDate: this.operationDate,
        metastasisYn: this.metastasisYn,
        metastasisPart: this.metastasisPart,
        anticancerDate: this.anticancerDate,
        radiotherapyDate: this.radiotherapyDate,
        antiagentYn: 'Y', //this.antiagentYn,
        antiagent: this.antiagent,
        medication: this.medication,
        anamnesisYn: this.anamnesisYn,
        anamnesis: anamnesis,
        anamnesisEtc: this.anamnesisEtc,
        nutritionMemo: this.nutritionMemo,
        kakao_sender: this.kakao_sender,
        mainCs: this.mainCs,
        mainCsCaller: this.mainCsCaller,
        mainCsCallerPhone: this.mainCsCallerPhone,
        initPath: this.initPath,
        patientPosition: this.patientPosition,
        etcMemo: this.etcMemo,
        tabSum_01: tabSum_01,
        roomMemo: this.roomMemo,
        csMemo: this.csMemo,
        cs2Memo: this.cs2Memo,
        cs3Memo: this.cs3Memo,
        followUpDate : this.followUpDate,
        inspectionDate : this.inspectionDate,
        consultDoctorUid : this.consultDoctorUid,
        wantedRoom1 : this.wantedRoom1,
        wantedRoom2 : this.wantedRoom2,
        wantedRoom3 : this.wantedRoom3,
        csDatas: this.csDatas,
      };

      console.log('[onClickModify] Sending params:', {
        patientUid: params.patientUid,
        patientUsername: params.patientUsername,
        address: params.address,
        bodyPart: params.bodyPart,
        diagnosisDate: params.diagnosisDate,
        operationDate: params.operationDate,
        metastasisYn: params.metastasisYn,
        anamnesis: params.anamnesis,
        csDatas_length: Array.isArray(params.csDatas) ? params.csDatas.length : 'not array'
      });

      if (!this.inDate) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'green',
          title: '확인',
          text: '입원예정일이 입력되지 않았습니다. 그대로 저장하시겠습니까?',
          position: 'center',
          acceptText: '네',
          cancelText: '계속 수정',
          accept: async () => {
            await this.checkChartNo(params, type);
          },
          cancel: function() {
            return false;
          }
        });
      } else {
        await this.checkChartNo(params, type);
      }

    },

    // 차트번호 입력 변경 시 예약 상태 초기화
    onChartNoInput() {
      this.chartNoReserved = false;
      this.chartNoDupWarning = false;
    },

    // 중복확인 버튼: PATIENT_MEMBER 중복 체크 + CHART_NO_RESERVATION 원자적 예약
    async checkAndReserveChartNo() {
      if (!this.chartNo || !this.patientUsername) return;

      this.chartNoChecking = true;
      this.chartNoReserved = false;
      this.chartNoDupWarning = false;

      try {
        const reservedUid = this.patientUid || ('new_' + Date.now());
        const response = await axiosClass.post('/api/patient/reserveChartNo', {
          chartNo: this.chartNo,
          patientUid: reservedUid,
          patientUsername: this.patientUsername,
          userUid: this.userUid,
          excludePatientUid: this.patientUid || '',
        }, true);

        const data = response.data;

        if (!data.reserved) {
          // PRIMARY KEY 충돌: 다른 담당자가 현재 예약 중
          this.chartNoDupWarning = true;
          this.$vs.notify({
            color: 'danger',
            title: '차트번호 사용 불가',
            text: '다른 담당자가 현재 해당 차트번호를 사용 중입니다.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return;
        }

        // 예약 성공: 이미 저장된 환자와 중복인지 경고 표시
        this.chartNoReserved = true;
        this.chartNoDupWarning = data.existsInMember;
        if (!this.patientUid) this.patientUid = data.patientUid;

        if (data.existsInMember) {
          this.$vs.notify({
            color: 'warning',
            title: '차트번호 중복 경고',
            text: '기존 환자와 차트번호가 중복됩니다. 계속 저장할 수 있습니다.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-triangle',
          });
        } else {
          this.$vs.notify({
            color: 'success',
            title: '차트번호 확인',
            text: '사용 가능한 차트번호입니다.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check',
          });
        }
      } catch (e) {
        console.error('[checkAndReserveChartNo]', e);
      } finally {
        this.chartNoChecking = false;
      }
    },

    async checkChartNo(params, type) {
      const regex = /^0*$/;
      const closeLoading = () => setTimeout(() => { this.$vs.loading.close('#memberView > .con-vs-loading'); }, 100);

      if (regex.test(params.chartNo)) {
        await this.modifyPatient(params, type);
        return;
      }

      let reserved = this.chartNoReserved;
      let dupWarning = this.chartNoDupWarning;

      // 중복확인 버튼을 누르지 않은 경우: 저장 시점에 직접 API 체크
      if (!reserved) {
        try {
          const response = await axiosClass.post('/api/patient/reserveChartNo', {
            chartNo: params.chartNo,
            patientUid: this.patientUid,
            patientUsername: this.patientUsername,
            userUid: this.userUid,
            excludePatientUid: this.patientUid || '',
          }, true);
          reserved = response.data.reserved;
          dupWarning = response.data.existsInMember;
          if (reserved) {
            this.chartNoReserved = true;
            this.chartNoDupWarning = dupWarning;
          }
        } catch (e) {
          closeLoading();
          return;
        }
      }

      // 다른 담당자가 현재 등록 중 → 확인 다이얼로그
      if (!reserved) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: '차트번호 사용 중',
          text: '다른 담당자가 현재 해당 차트번호로 등록 중입니다. 그래도 저장하시겠습니까?',
          position: 'center',
          acceptText: '저장',
          cancelText: '취소',
          accept: async () => { await this.modifyPatient(params, type); },
          cancel: closeLoading,
        });
        return;
      }

      // 기존 환자와 차트번호 중복 → 확인 다이얼로그
      if (dupWarning) {
        this.$vs.dialog({
          type: 'confirm',
          color: 'warning',
          title: '차트번호 중복',
          text: '기존 환자와 차트번호가 중복됩니다. 그래도 저장하시겠습니까?',
          position: 'center',
          acceptText: '저장',
          cancelText: '취소',
          accept: async () => { await this.modifyPatient(params, type); },
          cancel: closeLoading,
        });
        return;
      }

      await this.modifyPatient(params, type);
    },
    async modifyPatient(params, type) {
      let data;
      try {
        const response = await axiosClass.post('/api/patient/insert', params, true);
        data = response.data;
        if (!data.success) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: data.err_msg,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return;
        }
      } catch (error) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || '환자 정보 저장 중 오류가 발생했습니다. 다시 시도해주세요.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        return;
      }
      await this.releaseChartNoReservation();
      this.patientUid = data.returnUid;

      if (type == 'b') {
        this.$vs.notify({
          title: 'Success',
          text: '정상적으로 등록되었습니다.',
          color: 'success',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        this.patientUid = '';
        this.chartNo = '';
        this.patientUsername = '';
        this.sickNess = '';
        this.gisu = '';
        this.jumin = '';
        this.patientBirthday = '';
        this.patientGender = 'M';
        this.age = 0;
        this.plan = '';
        this.expire = false;
        this.newRe = '';
        this.cdStatus = '';
        this.inInitDate = '';
        this.inDate = '';
        this.inTime = '';
        this.outDate = '';
        this.completeYn = 'N';
        this.mealName = '';
        this.breakfast_mealName = '';
        this.lunch_mealName = '';
        this.dinner_mealName = '';
        this.medical_member_name = '';
        this.westMedicalNm = '';
        this.patientPhone = '';
        this.address = '';
        this.protector = '';
        this.protector2 = '';
        this.protectorPhone = '';
        this.protectorPhone2 = '';
        this.protectorYN = 'N';
        this.medicalName = '';
        this.memo = '';
        this.corona = 0;
        this.inFlowPath = "";
        this.bodyPart = '';
        this.diagnosisDate = '';
        this.operationDate = '';
        this.operationName = '';
        this.metastasisYn = '';
        this.metastasisPart = '';
        this.anticancerDate = '';
        this.radiotherapyDate = '';
        this.antiagentYn = 'Y';
        this.antiagent = '';
        this.medication = '';
        this.anamnesisYn = 'N';
        this.anamnesis = [];
        this.anamnesisEtc = '';
        this.nutritionMemo = '';
        this.openPopup1 = false;
        this.csPopup = false;
        this.kakao_sender = 1;
        // 20230515 TH 추가
        this.followUpDate = '';
        this.inspectionDate = '';
        this.consultDoctorUid = '';
        this.wantedRoom1 = '';
        this.wantedRoom2 = ''
        this.wantedRoom3 = ''
        this.oxygenPoint = 0;
        this.showOxygenCard = false;
        this.adjustedOxygenPoint = 0;
        //console.log('modify complete!');
        EventBus.$emit('remoteListRefresh');
      } else if (type == 't') {
        return true;
      }

      setTimeout(() => {
        this.openPopup = !this.openPopup;
      }, 100);
    },
    async onClickModifyCs(type) {
      if (this.isSaving) {
        return;
      }
      
      // patientUid 확인 및 설정
      if (!this.patientUid || this.patientUid === '') {
        console.error('patientUid is missing:', this.patientUid);
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: '환자 정보를 찾을 수 없습니다. 화면을 새로고침 해주세요.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        return;
      }

      if (this.patientUsername == '') {
        let err_msg = '';
        err_msg = '이름을 입력해주세요.';
        if (err_msg != '') {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: err_msg,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return;
        }
      }

      let err_msg = '';
      let objName = '';

      // csDatas가 빈 배열이면 상담내역 저장을 건너뜀 (기존 상담내역 보존)
      if (!this.csDatas || this.csDatas.length === 0) {
        console.log('[onClickModifyCs] csDatas가 비어있음 - 상담내역 저장 건너뜀');
      }

      // 편집된 데이터로 업데이트
      const updatedCsDatas = this.csDatas.map((csData, index) =>
        this.getUpdatedCsData(index, csData)
      );

      for (let i = 0; i < updatedCsDatas.length; i++) {
        const data = updatedCsDatas[i];
        // console.log('data:::', data);

        const csPathCode = data.CS_PATH_CODE;
        const csCateCode = data.CS_CATE_CODE;
        const csMeberCode = data.CS_MEMBER_CODE;
        const inquirer = data.INQUIRER;
        const phone = data.PHONE;
        const relation = data.RELATION;
        const csFavorCode = data.CS_FAVOR_CODE;
        const nextDate = data.NEXT_DATE;
        const csIssueCode = data.CS_ISSUE_CODE;
        const csIssueText = data.CS_ISSUE_TEXT;
        const csContent = data.CS_CONTENT.replace(/\\/g, "");
        

        //console.log('csFavorCode:' + csFavorCode);
        //console.log('nextDate:' + nextDate);

        if (csFavorCode == '') {
          this.$vs.notify({
            color: 'danger',
            title: '오류',
            text: '다음일정 종류를선택해주세요.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check',
          });
          return;
        }

        if (csFavorCode == 1 || csFavorCode == 3 || csFavorCode == 2) {
          // if (csFavorCode == 1 || csFavorCode == 3) {
          if (nextDate == '' || nextDate == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '예정일을 입력해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }
        }

        if (csFavorCode == 6 || csFavorCode == 7) {
          if (csIssueCode == '' || csIssueCode == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '부정이슈 종류를 선택해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }

          if (csFavorCode == 8) {
            if (csIssueText == '' || csIssueText == 'null') {
              this.$vs.notify({
                color: 'danger',
                title: '오류',
                text: '부정이슈 내용을 입력해주세요.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
              });
              return;
            }
          }
        }

        if (csFavorCode == 8) {
          if (csIssueCode == '' || csIssueCode == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '병실만실세부 종류를 선택해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }
        }
        if (csFavorCode == 9) {
          if (csIssueCode == '' || csIssueCode == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '기타세부 종류를 선택해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }
        }
      }
      const medicalName = this.medicalName == '직접입력' ? this.medicalNameText : this.medicalName;
      const insuranceName = this.insuranceName == "직접입력" ? this.insuranceNameText : this.insuranceName;
      const sickNess = this.sickNess == '직접입력' ? this.sickNessText : this.sickNess;
      const mealMemo = this.mealMemo == '직접입력' ? this.mealMemoText : this.mealMemo;
      // this.statusCheck(completeYn, inInitDate, inDate, outDate)
      // this.statusCheck();

      let anamnesis = '';
      for (let i = 0; i < this.anamnesis.length; i++) {
        let anamnesisText = this.anamnesis[i];
        if (anamnesis != '') anamnesisText = ',' + anamnesisText;
        anamnesis += anamnesisText;
      }
      const tabSum_01 = this.tabArray_01.reduce(function add(sum, currValue) {
        return sum + currValue;
      }, 0);
      let expireYN = this.expire == true ? 'Y' : 'N';


      // let errorMsg = '';

      // if (this.selectedMedicalCode.length < 0) {
      //     errorMsg = '치료실을 선택하여 주십시오.';
      // } else if (this.scheduleSelectDate == null || this.scheduleSelectDate == '') {
      //     errorMsg = '날짜를 선택해주세요.';
      // } else if (this.scheduleSelectTime == null || this.scheduleSelectTime == '') {
      //     errorMsg = '시간을 입력해주세요.';
      // } else if (this.viewManagerList.length > 0) {
      //     if (this.medicalManagers == '') {
      //         errorMsg = '치료자를 선택하여 주십시오.';
      //     }
      // }

      // if (this.search.length == 0) {
      //     errorMsg = '환자를 선택하여 주십시오.';
      // } else if (this.viewDetailList.length > 0) {
      //     if (this.medicalDetails == '') {
      //         errorMsg = '스케줄을 선택하여 주십시오.';
      //     }
      // }

      // if (errorMsg != '') {
      //     this.$vs.notify({
      //         title: 'Error',
      //         text: errorMsg,
      //         color: 'danger',
      //         position: 'top-right',
      //         iconPack: 'feather',
      //         icon: 'icon-check',
      //     });
      //     return;
      // }

      // console.log(this.$store.getters.getUID);

      if (this.$store.getters.getUID == null || this.$store.getters.getUID == undefined) {
        this.$vs.notify({
          color: 'danger',
          title: '오류',
          text: '사용자를 찾을 수 없습니다. 새로고침을 해주세요(F5).',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        return;
      }

      let params = {
        patientUid: this.patientUid,
        chartNo: this.chartNo,
        patientUsername: this.patientUsername,
        sickNess: sickNess,
        gisu: this.gisu,
        jumin: this.jumin,
        patientBirthday: this.patientBirthday,
        patientGender: this.patientGender,
        age: this.age,
        plan: this.plan,
        expire: expireYN,
        newRe: this.newRe,
        cdStatus: this.cdStatus,
        inInitDate: this.inInitDate,
        inDate: this.inDate,
        inTime: this.inTime,
        outTime: this.outTime,
        outDate: this.outDate,
        completeYn: this.completeYn,
        mealTime: this.mealTime,
        mealName: this.mealName,
        mealMemo: mealMemo,
        breakfast_mealName: this.breakfast_mealName,
        lunch_mealName: this.lunch_mealName,
        dinner_mealName: this.dinner_mealName,
        medical_member_name: this.medical_member_name,
        westMedicalNm: this.westMedicalNm,
        patientPhone: this.patientPhone,
        address: this.address,
        protectorPhone: this.protectorPhone,
        protectorPhone2: this.protectorPhone2,
        protectorYN: this.protectorYN,
        protector: this.protector,
        protector2: this.protector2,
        medicalName: medicalName,
        memo: this.memo,
        corona: this.corona,
        inFlow: this.inFlowPath,
        medicalRoomNumberNm: this.medicalRoomNumberNm,
        medicalRoomNumberCnt: this.medicalRoomNumberCnt,
        bodyPart: this.bodyPart,
        diagnosisDate: this.diagnosisDate,
        operationDate: this.operationDate,
        operationName: this.operationName,
        metastasisYn: this.metastasisYn,
        metastasisPart: this.metastasisPart,
        anticancerDate: this.anticancerDate,
        radiotherapyDate: this.radiotherapyDate,
        antiagentYn: 'Y', //this.antiagentYn,
        antiagent: this.antiagent,
        medication: this.medication,
        anamnesisYn: this.anamnesisYn,
        anamnesis: anamnesis,
        anamnesisEtc: this.anamnesisEtc,
        nutritionMemo: this.nutritionMemo,
        // 알림톡 수신자 추가
        kakao_sender: this.kakao_sender,
        mainCs: this.mainCs,
        mainCsCaller: this.mainCsCaller,
        mainCsCallerPhone: this.mainCsCallerPhone,
        initPath: this.initPath,
        patientPosition: this.patientPosition,
        etcMemo: this.etcMemo,
        tabSum_01: tabSum_01,
        roomMemo: this.roomMemo,
        csMemo: this.csMemo,
        cs2Memo: this.cs2Memo,
        cs3Memo: this.cs3Memo,
        // csDatas가 빈 배열이면 undefined로 전달하여 기존 상담내역 보존
        csDatas: (this.csDatas && this.csDatas.length > 0) ? this.csDatas : undefined,
        insuranceName: this.insuranceName,
        silbiJoinPeriod: this.silbiJoinPeriod,
        insuranceText: this.insuranceNameText,
        joinDate: this.joinDate,
        inLimit: this.inLimit,
        inLimittext: this.inLimitText,
        inGuarantee: this.inGuarantee,
        balance: this.balance,
        confirmDate: this.confirmDate,
        outpatDayLimit: this.outpatDayLimit,
        outpatDayLimitText: this.outpatDayLimitText,
        outPatCount: this.outPatCount,
        indemStdt: this.indemStdt,
        indemEnddt: this.indemEnddt,
        // 20230515 TH 추가
        followUpDate: this.followUpDate,
        inspectionDate: this.inspectionDate,
        consultDoctorUid : this.consultDoctorUid,
        wantedRoom1 : this.wantedRoom1,
        wantedRoom2 : this.wantedRoom2,
        wantedRoom3 : this.wantedRoom3,

      };

      console.log('[onClickModifyCs] Sending params:', {
        patientUid: params.patientUid,
        patientUsername: params.patientUsername,
        address: params.address,
        bodyPart: params.bodyPart,
        csDatas_length: Array.isArray(params.csDatas) ? params.csDatas.length : 'not array',
        sample_fields: {
          diagnosisDate: params.diagnosisDate,
          operationDate: params.operationDate,
          metastasisYn: params.metastasisYn
        }
      });

      this.isSaving = true;
      this.$vs.loading();

      console.log('[onClickModifyCs] 저장 시작 - API 호출 직전:', {
        timestamp: new Date().toISOString(),
        patientUid: params.patientUid,
        patientUsername: params.patientUsername
      });

      try {
        const { data } = await axiosClass.post('/api/patient/insert', params, true);
        console.log('[onClickModifyCs] API 응답 수신:', { success: data.success, returnUid: data.returnUid });

        if (!data.success) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: data.err_msg,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return;
        }

        this.patientUid = data.returnUid;
        
        // 편집 상태 초기화
        this.csEditingStates = {};
        
        // 20230427 TH 추가
        // 카카오워크 봇에 메세지 보내는 로직
        // 다음일정이 리콜필요 이고 다음일정 리콜이 당일일 경우
        // 문의 종류가 리콜인 경우 제외
        if(this.csDatas != null && this.csDatas != undefined && this.csDatas != ''){
          console.log('[KakaoWork Debug] csDatas 체크 통과:', {
            csDatas_length: this.csDatas.length,
            NEXT_DATE: this.csDatas[0].NEXT_DATE,
            now_date: this.now_date,
            CS_FAVOR_CODE: this.csDatas[0].CS_FAVOR_CODE,
            CS_CATE_CODE: this.csDatas[0].CS_CATE_CODE
          });

          if(this.csDatas[0].NEXT_DATE == this.now_date && this.csDatas[0].CS_FAVOR_CODE == 3 && this.csDatas[0].CS_CATE_CODE != 7) {
            console.log('[KakaoWork Debug] 조건 모두 충족! sendKakaoWorkBot 호출 시작');
            await this.sendKakaoWorkBot();
            console.log('[KakaoWork Debug] sendKakaoWorkBot 호출 완료');
          } else {
            console.log('[KakaoWork Debug] 조건 불충족:', {
              날짜_일치: this.csDatas[0].NEXT_DATE == this.now_date,
              CS_FAVOR_CODE_체크: this.csDatas[0].CS_FAVOR_CODE == 3,
              CS_CATE_CODE_체크: this.csDatas[0].CS_CATE_CODE != 7
            });
          }
        } else {
          console.log('[KakaoWork Debug] csDatas가 null/undefined/빈값:', this.csDatas);
        }
        // TH 끝

        this.openPopup1 = false;
        this.csPopup = false;
        this.csDatas = [];
        this.displayedCsDatas = [];
        await this.init(this.medical_room_seq);
        this.$vs.notify({
          title: 'Success',
          text: '정상적으로 등록되었습니다.',
          color: 'success',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        EventBus.$emit('remoteListCsRefresh');
      } catch (error) {
        console.error('[onClickModifyCs] API 호출 실패:', {
          timestamp: new Date().toISOString(),
          error: error.message,
          response: error.response
        });
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: (error.response && error.response.data && error.response.data.message) || '환자 상담 정보 저장 중 오류가 발생했습니다. 페이지를 새로고침하고 다시 시도해주세요.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
      } finally {
        this.isSaving = false;
        this.$vs.loading.close();
      }
    },

    addClickCs() {
      const tempCsData = {
        CS_CATE_CODE: '',
        CS_CONTENT: '',
        CS_DATE: dateClass.getDate('YYYY-MM-DD'),
        CS_TIME: dateClass.getDate('HH:mm:ss'),
        CS_FAVOR_CODE: '',
        CS_ISSUE_CODE: '',
        CS_MEMBER_CODE: this.userUid,
        CS_PATH_CODE: '',
        INQUIRER: this.mainCsCaller,
        NEXT_DATE: dateClass.getDate("YYYY-MM-DD"),
        PATIENT_UID: this.patientUid,
        PHONE: '',
        RELATION: '',
        SEQ: 0,
        CS_ISSUE_TEXT: '',
      };
      this.csAddYN = 'Y';
      this.csDatas.unshift(tempCsData);
      // 표시 데이터도 업데이트
      this.initializeDisplayedData();
    },

    // 20210607 홍현표 수정
    async removeClickCs(index) {
      const csSeq = this.csDatas[index].SEQ;

      if (csSeq > 0) {
        try {
          await axiosClass.delete('/api/patient/cs/' + csSeq, true);
        } catch (error) {
          console.error('[removeClickCs] 삭제 실패:', error);
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: '상담내역 삭제 중 오류가 발생했습니다. 다시 시도해주세요.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return; // Don't remove from UI if server delete failed
        }

        this.$vs.notify({
          title: 'Success',
          text: '상담내역이 삭제되었습니다.',
          color: 'success',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
      }

      this.csDatas.splice(index, 1);
      // 표시 데이터도 업데이트
      const displayIndex = this.displayedCsDatas.findIndex(item => item.SEQ === csSeq);
      if (displayIndex > -1) {
        this.displayedCsDatas.splice(displayIndex, 1);
      }

      EventBus.$emit('remoteListCsRefresh');
      this.$vs.notify({
        color: 'danger',
        title: '삭제 완료',
        text: '삭제가 완료되었습니다.',
        position: 'top-right',
        iconPack: 'feather',
        icon: 'icon-check',
      });
    },
    async saveClickCs(type) {
      if (this.csDatas.length < 1) {
        this.$vs.notify({
          color: 'danger',
          title: '오류',
          text: '상담내역이 존재하지 않습니다.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        return;
      }
      let err_msg = '';
      let objName = '';
      for (let i = 0; i < this.csDatas.length; i++) {
        const data = this.csDatas[i];
        // console.log('data:::', data);

        const csPathCode = data.CS_PATH_CODE;
        const csCateCode = data.CS_CATE_CODE;
        const csMeberCode = data.CS_MEMBER_CODE;
        const inquirer = data.INQUIRER;
        const phone = data.PHONE;
        const relation = data.RELATION;
        const csFavorCode = data.CS_FAVOR_CODE;
        const nextDate = data.NEXT_DATE;
        const csIssueCode = data.CS_ISSUE_CODE;
        const csIssueText = data.CS_ISSUE_TEXT;
        const csContent = data.CS_CONTENT.replace(/\\/g, "");
        
        // if (csPathCode == 0 || csPathCode == '') {
        //     err_msg = '경로(를)을 입력해주세요.';
        //     objName = 'csPathCode';
        // } else if (csCateCode == 0 || csCateCode == '') {
        //     err_msg = '문의종류(를)을 입력해주세요.';
        //     objName = 'csCateCode';
        // }
        // else if (csMeberCode == 0 || csMeberCode == '') {
        //     err_msg = '담당자(를)을 입력해주세요.';
        //     objName = 'csMeberCode';
        // } else if (inquirer.trim() == '') {
        //     err_msg = '문의자(를)을 입력해주세요.';
        //     objName = 'inquirer';
        // } else if (phone.trim() == '') {
        //     err_msg = '연락처(를)을 입력해주세요.';
        //     objName = 'phone';
        // } else if (relation.trim() == '') {
        //     err_msg = '관계(를)을 입력해주세요.';
        //     objName = 'relation';
        // } else if (csFavorCode == 0 || csFavorCode == '') {
        //     err_msg = '호의도(를)을 입력해주세요.';
        //     objName = 'csFavorCode';
        // } else if (nextDate.trim() == '') {
        //     err_msg = '다음일정(를)을 입력해주세요.';
        //     objName = 'nextDate';
        // } else if (csIssueCode == 0 || csIssueCode == '') {
        //     err_msg = '부정이슈 종류(를)을 입력해주세요.';
        //     objName = 'csIssueCode';
        // } else if (csContent.trim() == '') {
        //     err_msg = '상담내역(를)을 입력해주세요.';
        //     objName = 'csContent';
        // }
        // 20210607 홍현표 수정
        //console.log('csFavorCode:' + csFavorCode);
        //console.log('nextDate:' + nextDate);

        if (csFavorCode == '') {
          this.$vs.notify({
            color: 'danger',
            title: '오류',
            text: '다음일정 종류를선택해주세요.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check',
          });
          return;
        }

        if (csFavorCode == 1 || csFavorCode == 2 || csFavorCode == 3) {
          if (nextDate == '' || nextDate == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '예정일을 입력해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }
        }

        if (csFavorCode == 6 || csFavorCode == 7) {
          if (csIssueCode == '' || csIssueCode == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '부정이슈 종류를 선택해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }

          if (csIssueCode == 8) {
            if (csIssueText == '' || csIssueText == 'null') {
              this.$vs.notify({
                color: 'danger',
                title: '오류',
                text: '부정이슈 내용을 입력해주세요.',
                position: 'top-right',
                iconPack: 'feather',
                icon: 'icon-check',
              });
              return;
            }
          }
        }
        if (csFavorCode == 8) {
          if (csIssueCode == '' || csIssueCode == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '병실만실세부 종류를 선택해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }
        }
        if (csFavorCode == 9) {
          if (csIssueCode == '' || csIssueCode == 'null') {
            this.$vs.notify({
              color: 'danger',
              title: '오류',
              text: '기타세부 종류를 선택해주세요.',
              position: 'top-right',
              iconPack: 'feather',
              icon: 'icon-check',
            });
            return;
          }
        }
        if (err_msg != '') {
          this.$vs.notify({
            color: 'danger',
            title: '오류',
            text: err_msg,
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check',
          });

          if (objName == 'nextDate') {
            const dateDiv = document.querySelectorAll('div[name="' + objName + '"]')[i];
            const dateInput = dateDiv.querySelector('input[name="date"]');
            dateInput.focus();
          } else if (objName == 'csContent') {
            document.querySelectorAll('textarea[name="' + objName + '"]')[i].focus();
          } else {
            document.querySelectorAll('input[name="' + objName + '"]')[i].focus();
          }

          return;
        }
      }

      const changedDatas = this.getChangedCsDatas();

      if (changedDatas.length === 0) {
        this.$vs.notify({
          title: '알림',
          text: '변경된 내용이 없습니다.',
          color: 'primary',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-info',
        });
        return;
      }

      const params = {
        csDatas: changedDatas,
      };
      // console.log('params:::', params);

      try {
        const { data } = await axiosClass.post('/api/patient/cs/' + this.patientUid, params, true);

        if (!data.success) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: data.err_msg || '상담 정보 저장에 실패했습니다.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return;
        }

        if (type != 'save') {
          this.$vs.notify({
            title: 'Success',
            text: '정상적으로 등록되었습니다.',
            color: 'success',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check',
          });
          this.csDatas = [];
          this.displayedCsDatas = [];
          // await this.onClickModifyCs('csSave');
        }

        // EventBus.$emit('remoteListCsRefresh');

        await this.onClickCs();

        setTimeout(() => {
          this.$vs.loading.close('#list > .con-vs-loading');
          this.openPopup1 = false;
          this.csPopup = false;
        }, 100);
      } catch (error) {
        console.error('[saveClickCs] 저장 실패:', error);
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: '상담 정보 저장 중 오류가 발생했습니다. 네트워크 연결을 확인하고 다시 시도해주세요.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
      }
    },
    async memberSelect() {
      this.userUid = store.getters.getUID;

      if (this.userUid == null || this.userUid == undefined) {
        this.$vs.notify({
          color: 'danger',
          title: '오류',
          text: '사용자를 찾을 수 없습니다. 새로고침을 해주세요(F5).',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
        return;
      }

      // uid가 없으면 신규 환자 등록 모드 - 데이터 초기화
      if (!this.uid || this.uid === 'undefined' || this.uid === undefined || this.uid === '') {
        console.log('[MemerView] uid is empty, initializing for new patient');
        this.resetFormData();
        return;
      }

      let params = {
        userUid: this.userUid,
      };

      let data;
      try {
        const response = await axiosClass.get(`/api/patient/view/${this.uid}`, params, true);
        data = response.data;
        //console.log(data.memberData);
      } catch (error) {
        console.error('[onClickMemberView] 환자 정보 로드 실패:', error);
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: '환자 정보를 불러오는 중 오류가 발생했습니다. 페이지를 새로고침해주세요.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
        // Set empty state to prevent UI crash
        this.resetFormData();
        return;
      }

      const dataLengthCheck = data && data.memberData ? Object.keys(data.memberData).length : 0;
      //console.log(dataLengthCheck);

      // 각종 리스트 데이터 설정
      if (data) {
        if (data.mealNameList) this.mealNameList = data.mealNameList;
        if (data.mealTimeList) this.mealTimeList = data.mealTimeList;
        if (data.mealMemoList) this.mealMemoList = data.mealMemoList;
        if (data.statusList) this.statusList = data.statusList;
        if (data.medicalMemberList) this.medicalMemberList = data.medicalMemberList;
        if (data.medicalCenterList) this.medicalCenterList = data.medicalCenterList;
        if (data.insuranceCenterList) this.insuranceCenterList = data.insuranceCenterList;
        if (data.protectorList) this.protectorList = data.protectorList;
        if (data.coronaList) this.coronaList = data.coronaList;
        if (data.bodyPartList) this.bodyPartList = data.bodyPartList;
        if (data.anamnesisList) this.anamnesisList = data.anamnesisList;
      }

      //console.log(this.statusList);
      this.medicalRoomNumberListEtc = dataLengthCheck == 0 || !data || !data.medicalRoomNumberListEtc ? "" : data.medicalRoomNumberListEtc;

      this.popTabIdx = 1;
      // 새 환자인 경우 UUID 생성
      this.patientUid = dataLengthCheck == 0 ? uuidv4() : (data && data.memberData && data.memberData.PATIENT_UID ? data.memberData.PATIENT_UID : uuidv4());
      this.chartNo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CHART_NO ? data.memberData.CHART_NO : "");
      this.patientUsername = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PATIENT_USERNAME ? data.memberData.PATIENT_USERNAME : "");
      this.sickNess = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.SICKNESS ? data.memberData.SICKNESS : "");
      this.gisu = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.GISU ? data.memberData.GISU : "");
      this.jumin = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PATIENT_JUMIN ? data.memberData.PATIENT_JUMIN : "");
      this.patientBirthday = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PATIENT_BIRTHDAY ? data.memberData.PATIENT_BIRTHDAY : "");
      this.patientGender = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PATIENT_GENDER ? data.memberData.PATIENT_GENDER : "");
      this.age = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PATIENT_AGE ? data.memberData.PATIENT_AGE : "");
      this.plan = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PLAN ? data.memberData.PLAN : "");
      // this.classInfo = data.memberData.;
      this.newRe = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.NEW_RE ? data.memberData.NEW_RE : "");
      this.cdStatus = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CD_STATUS ? data.memberData.CD_STATUS : "");
      this.initCdStatus = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CD_STATUS ? data.memberData.CD_STATUS : "");
      this.inInitDate = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.IN_INIT_DATE ? data.memberData.IN_INIT_DATE : "");
      this.inDate = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.IN_DATE ? data.memberData.IN_DATE : "");
      this.inTime = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.IN_TIME ? data.memberData.IN_TIME : "");
      this.outTime = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.OUT_TIME ? data.memberData.OUT_TIME : "");
      this.outDate = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.OUT_DATE ? data.memberData.OUT_DATE : "");
      this.completeYn = dataLengthCheck == 0 ? "N" : (data && data.memberData && data.memberData.COMPLATE_YN ? data.memberData.COMPLATE_YN : "N");
      this.mealTime = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEAL_TIME ? data.memberData.MEAL_TIME : "");
      this.mealName = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEAL_NAME ? data.memberData.MEAL_NAME : "");
      this.mealMemo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEAL_MEMO ? data.memberData.MEAL_MEMO : "");
      this.breakfast_mealName = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.BREAKFAST_MEAL_NAME ? data.memberData.BREAKFAST_MEAL_NAME : "");
      this.lunch_mealName = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.LUNCH_MEAL_NAME ? data.memberData.LUNCH_MEAL_NAME : "");
      this.dinner_mealName = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.DINNER_MEAL_NAME ? data.memberData.DINNER_MEAL_NAME : "");
      this.medical_member_name = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEDICAL_NM ? data.memberData.MEDICAL_NM : "");
      this.westMedicalNm = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.WEST_MEDICAL_NM ? data.memberData.WEST_MEDICAL_NM : "");
      this.patientPhone = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PATIENT_PHONE ? data.memberData.PATIENT_PHONE : "");
      this.address = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.ADDRESS ? data.memberData.ADDRESS : "");
      this.protectorPhone = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PROTECTOR_PHONE ? data.memberData.PROTECTOR_PHONE : "");
      this.protectorPhone2 = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PROTECTOR_PHONE2 ? data.memberData.PROTECTOR_PHONE2 : "");
      this.protectorYN = dataLengthCheck == 0 ? "N" : (data && data.memberData && data.memberData.PROTECTOR_YN ? data.memberData.PROTECTOR_YN : "N");
      this.protector = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PROTECTOR ? data.memberData.PROTECTOR : "");
      this.protector2 = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.PROTECTOR2 ? data.memberData.PROTECTOR2 : "");
      this.bodyPart = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.BODYPART ? data.memberData.BODYPART : "");
      this.diagnosisDate = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.DIAGNOSIS_DATE ? data.memberData.DIAGNOSIS_DATE : "");
      this.operationDate = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.OPERATION_DATE ? data.memberData.OPERATION_DATE : "");
      this.operationName = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.OPERATION_NAME ? data.memberData.OPERATION_NAME : "");
      this.metastasisYn = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.METASTASIS_YN ? data.memberData.METASTASIS_YN : "");
      this.metastasisPart = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.METASTASIS_PART ? data.memberData.METASTASIS_PART : "");
      this.anticancerDate = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.ANTICANCER_DATE ? data.memberData.ANTICANCER_DATE : "");
      this.radiotherapyDate = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.RADIOTHERAPY_DATE ? data.memberData.RADIOTHERAPY_DATE : "");
      this.antiagentYn = 'Y'; //data.memberData.ANTIAGENT_YN;
      this.antiagent = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.ANTIAGENT ? data.memberData.ANTIAGENT : "");
      this.medication = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEDICATION ? data.memberData.MEDICATION : "");
      this.anamnesisYn = dataLengthCheck == 0 ? "N" : (data && data.memberData && data.memberData.ANAMNESIS_YN ? data.memberData.ANAMNESIS_YN : "N");
      this.anamnesis = [];
      this.nutritionMemo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.NUTRITION_MEMO ? data.memberData.NUTRITION_MEMO : "");
      this.kakao_sender = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.KAKAO_SENDER ? data.memberData.KAKAO_SENDER : "");
      

      // 230413 TH 추가
      this.insuranceChk = false;
      this.inGuarantee = "";
      this.balance  = "";
      this.confirmDate  =  dateClass.getDate("YYYY-MM-DD");
      this.outpatDayLimit = "";
      this.outpatDayLimitText = "";
      this.outPatCount = "";
      this.indemStdt = "";
      this.indemEnddt = "";
      

      if (data && data.memberData && data.memberData.ANAMNESIS && data.memberData.ANAMNESIS != '' && data.memberData.ANAMNESIS != undefined) {
        //console.log(data.memberData.ANAMNESIS);
        const anamnesisArray = data.memberData.ANAMNESIS.trim().split(',');
        this.anamnesis = anamnesisArray;
      }

      this.anamnesisEtc = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.ANAMNESIS_ETC ? data.memberData.ANAMNESIS_ETC : "");

      if (!data || !data.memberData || !data.memberData.MEDICAL_NAME || data.memberData.MEDICAL_NAME == '') {
        this.medicalName = '';
        this.medicalNameText = '';
      } else {
        let nameTF = false;
        for (let i = 0; i < this.medicalCenterList.length; i++) {
          const medicalName = this.medicalCenterList[i].MEDICAL_CENTER_NAME;
          if (data && data.memberData && medicalName == data.memberData.MEDICAL_NAME) {
            this.medicalName = data.memberData.MEDICAL_NAME;
            this.medicalNameText = '';
            nameTF = true;
          }
        }
        if (!nameTF) {
          this.medicalName = '직접입력';
          this.medicalNameText = data && data.memberData && data.memberData.MEDICAL_NAME ? data.memberData.MEDICAL_NAME : '';
        }
      }

      if (!data || !data.memberData || !data.memberData.SILBI_JOIN_PERIOD || data.memberData.SILBI_JOIN_PERIOD == "") {
        this.silbiJoinPeriod = "";
      } else {
        this.silbiJoinPeriod = data.memberData.SILBI_JOIN_PERIOD;
        this.insuranceChk = true;
      }

      if (!data || !data.memberData || !data.memberData.INSURANCENAME || data.memberData.INSURANCENAME == "") {
        this.insuranceName = "";
        this.insuranceNameText = "";
      } else if (data.memberData.INSURANCENAME == "직접입력") {
        this.insuranceName = "직접입력";
        this.insuranceNameText = data.memberData.INSURANCENAMETEXT ? data.memberData.INSURANCENAMETEXT : "";
        this.insuranceChk = true;
      } else {
        let nameTF = false;
        for (let i = 0; i < this.insuranceCenterList.length; i++) {
          const insuranceName = this.insuranceCenterList[i].INSURANCE_CENTER_CODE;
          if (data && data.memberData && insuranceName == data.memberData.INSURANCENAME) {
            this.insuranceName = data.memberData.INSURANCENAME;
            this.insuranceNameText = "";
            nameTF = true;
            this.insuranceChk = true;
          }
        }
        if (!nameTF) {
          this.insuranceName = "";
          this.insuranceNameText = "초기값";
        }
      }


      if (!data || !data.memberData || !data.memberData.INLIMIT || data.memberData.INLIMIT == "") {
        this.inLimit = "";
        this.inLimitText = "";
      } else  if (data.memberData.INLIMIT == "etc") {
        this.inLimit = "etc";
        this.inLimitText = data.memberData.INLIMITTEXT ? data.memberData.INLIMITTEXT : "";
      } else {
        this.inLimit = data.memberData.INLIMIT;
        this.inLimitText = "";
      }

      if (!data || !data.memberData || !data.memberData.INGUARANTEE || data.memberData.INGUARANTEE == "") {
        this.inGuarantee = "";
      } else {
        this.inGuarantee = data.memberData.INGUARANTEE;
      }

      if (!data || !data.memberData || !data.memberData.BALANCE || data.memberData.BALANCE == "") {
        this.balance = "";
        this.confirmDate  =  dateClass.getDate("YYYY-MM-DD");
      } else {
        this.balance = data.memberData.BALANCE;
        this.confirmDate = data.memberData.CONFIRMDATE ? data.memberData.CONFIRMDATE : dateClass.getDate("YYYY-MM-DD");
      }

      if (!data || !data.memberData || !data.memberData.OUTPATDAYLIMIT) {
        this.outpatDayLimit = "";
        this.outpatDayLimitText = "";
      } else if (data.memberData.OUTPATDAYLIMIT == "ETC") {
        this.outpatDayLimit = data.memberData.OUTPATDAYLIMIT;
        this.outpatDayLimitText  = data.memberData.OUTPATDAYLIMITTEXT ? data.memberData.OUTPATDAYLIMITTEXT : "";
      } else {
        this.outpatDayLimit = data.memberData.OUTPATDAYLIMIT;
        this.outpatDayLimitText = "";
      }

      if (!data || !data.memberData || !data.memberData.OUTPATCOUNT || data.memberData.OUTPATCOUNT == "") {
        this.outPatCount = "";
      } else {
        this.outPatCount = data.memberData.OUTPATCOUNT;
      }

      if (!data || !data.memberData || !data.memberData.INDEMSTDT || data.memberData.INDEMSTDT == "") {
        this.indemStdt = "";
      } else {
        this.indemStdt = data.memberData.INDEMSTDT;
      }

      if (!data || !data.memberData || !data.memberData.INDEMENDDT || data.memberData.INDEMENDDT == "") {
        this.indemEnddt = "";
      } else {
        this.indemEnddt = data.memberData.INDEMENDDT;
      }

      if (!data || !data.memberData || !data.memberData.SICKNESS || data.memberData.SICKNESS == '') {
        this.sickNess = '';
        this.sickNessText = '';
      } else {
        let nameTF = false;
        for (let i = 0; i < this.sickNessList.length; i++) {
          const sickNess = this.sickNessList[i].SICKNESS;
          if (sickNess == data.memberData.SICKNESS) {
            this.sickNess = data.memberData.SICKNESS;
            this.sickNessText = '';
            nameTF = true;
          }
        }
        if (!nameTF) {
          this.sickNess = '직접입력';
          this.sickNessText = data.memberData.SICKNESS;
        }
      }

      if (!data || !data.memberData || !data.memberData.MEAL_MEMO || data.memberData.MEAL_MEMO == '') {
        this.mealMemo = '';
        this.mealMemoText = '';
      } else {
        let nameTF = false;
        for (let i = 0; i < this.mealMemoList.length; i++) {
          const mealMemo = this.mealMemoList[i].MEALMEMO;
          if (mealMemo == data.memberData.MEAL_MEMO) {
            this.mealMemo = data.memberData.MEAL_MEMO;
            this.mealMemoText = '';
            nameTF = true;
          }
        }
        if (!nameTF) {
          this.mealMemo = '직접입력';
          this.mealMemoText = data && data.memberData && data.memberData.MEAL_MEMO ? data.memberData.MEAL_MEMO : '';
        }
      }

      this.memo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEMO ? data.memberData.MEMO : "");
      this.corona = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CORONA ? data.memberData.CORONA : "");
      this.inFlowPath = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.INFLOW ? data.memberData.INFLOW : "");
      this.medicalRoomNm = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEDICAL_ROOM_NM ? data.memberData.MEDICAL_ROOM_NM : "");

      this.medicalRoomNumberNm = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEDICAL_ROOM_NUMBER_NM ? data.memberData.MEDICAL_ROOM_NUMBER_NM : "");
      this.medicalRoomNumberCnt = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEDICAL_ROOM_NUMBER_CNT ? data.memberData.MEDICAL_ROOM_NUMBER_CNT : "");

      this.initMedicalRoomNumberNm = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEDICAL_ROOM_NUMBER_NM ? data.memberData.MEDICAL_ROOM_NUMBER_NM : "");
      this.initMedicalRoomNumberCnt = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MEDICAL_ROOM_NUMBER_CNT ? data.memberData.MEDICAL_ROOM_NUMBER_CNT : "");

      if (this.addrOptions.length == 0) {
        let addrOptions_Obj = {};
        addrOptions_Obj.group = [];
        if (data && data.addressList && data.addressList.length > 0) {
          for (let i = 0; i < data.addressList.length; i++) {
            const obj = data.addressList[i];
            const _do = obj.DO;
            const _bf_do = i > 0 ? data.addressList[i - 1].DO : '';
            const _si = obj.SI;
            const groupObj = { text: _si, value: _si };
            if (_do != _bf_do) {
              if (i > 0) {
                this.addrOptions.push(addrOptions_Obj);
              }
              addrOptions_Obj = {};
              addrOptions_Obj.group = [];
              addrOptions_Obj.title = _do;
            } else {
              if (data.addressList.length == i + 1) {
                this.addrOptions.push(addrOptions_Obj);
              }
            }
            addrOptions_Obj.group.push(groupObj);
          }
        }
      }
      if (this.medicalRoomNm != '') await this.medicalRoomChange('Y');
      if (this.medicalRoomNumberNm != '') await this.medicalRoomNumberChange('Y');

      this.kakao_sender = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.KAKAO_SENDER ? data.memberData.KAKAO_SENDER : "");
      this.tabArray_01 = [];

      if (data && data.memberData && data.memberData.TABSUM) {
        for (let i = 0; i < this.moduleRoomlist.length; i++) {
          //console.log(this.moduleRoomlist[i].TAB_CODE);
          if ((data.memberData.TABSUM & this.moduleRoomlist[i].TAB_CODE) != false) {
            this.tabArray_01.push(this.moduleRoomlist[i].TAB_CODE);
          }
        }
      }

      this.mainCs = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MAIN_CS_UID ? data.memberData.MAIN_CS_UID : "");
      this.mainCsCaller = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MAIN_CS_CALLER ? data.memberData.MAIN_CS_CALLER : "");
      this.mainCsCallerPhone = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.MAIN_CALLER_PHONE ? data.memberData.MAIN_CALLER_PHONE : "");
      this.initPath = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.INITPATH ? data.memberData.INITPATH : "");
      this.patientPosition = dataLengthCheck == 0 ? 1 : (data && data.memberData && data.memberData.PATIENT_POSITION ? data.memberData.PATIENT_POSITION : 1);
      this.etcMemo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.ETC_MEMO ? data.memberData.ETC_MEMO : "");
      this.roomMemo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.ROOM_MEMO ? data.memberData.ROOM_MEMO : "");
      this.csMemo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CS_MEMO ? data.memberData.CS_MEMO : "");
      this.cs2Memo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CS2_MEMO ? data.memberData.CS2_MEMO : "");
      this.cs3Memo = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CS3_MEMO ? data.memberData.CS3_MEMO : "");
      this.csAddYN = 'N';
      this.consultDoctorUid = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.CONSULT_DOCTOR_UID ? data.memberData.CONSULT_DOCTOR_UID : "");
      this.wantedRoom1 = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.WANTED_ROOM1 ? data.memberData.WANTED_ROOM1 : "");
      this.wantedRoom2 = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.WANTED_ROOM2 ? data.memberData.WANTED_ROOM2 : "");
      this.wantedRoom3 = dataLengthCheck == 0 ? "" : (data && data.memberData && data.memberData.WANTED_ROOM3 ? data.memberData.WANTED_ROOM3 : "");

      this.oxygenPoint = dataLengthCheck == 0 ? "" : (data && data.oxygenPoint && data.oxygenPoint.POINT_VALUE ? data.oxygenPoint.POINT_VALUE : 0);
      
      this.showOxygenCard = false;
      this.adjustedOxygenPoint = 0;
    },

    getPhoneMask(val, type) {
      let res = this.getMask(val);
      if (type == 'patientPhone') {
        this.patientPhone = res;
        //서버 전송 값에는 '-' 를 제외하고 숫자만 저장
        // this.patientPhone = this.patientPhone.replace(/[^0-9]/g, '');
      }
      if (type == 'protectorPhone') {
        this.protectorPhone = res;
      }
      if (type == 'protectorPhone2') {
        this.protectorPhone2 = res;
      }
      if (type == 'mainCsCallerPhone') {
        if (this.mainCsCaller == '') {
          this.mainCsCallerPhone = '';
        } else {
          this.mainCsCallerPhone = res;
        }
      }
    },

    getMask(phoneNumber) {
      if (!phoneNumber) return phoneNumber;
      phoneNumber = phoneNumber.replace(/[^0-9)]/g, '');

      let res = '';
      if (phoneNumber.length < 3) {
        res = phoneNumber;
      } else {
        if (phoneNumber.substr(0, 2) == '02') {
          if (phoneNumber.length <= 5) {
            //02-123-5678
            res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3);
          } else if (phoneNumber.length > 5 && phoneNumber.length <= 9) {
            //02-123-5678
            res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 3) + '-' + phoneNumber.substr(5);
          } else if (phoneNumber.length > 9) {
            //02-1234-5678
            res = phoneNumber.substr(0, 2) + '-' + phoneNumber.substr(2, 4) + '-' + phoneNumber.substr(6);
          }
        } else if(phoneNumber.substr(0, 3) == '010') {
          if (phoneNumber.length < 8) {
            res = phoneNumber;
          } else if (phoneNumber.length == 8) {
            res = phoneNumber.substr(0, 4) + '-' + phoneNumber.substr(4);
          } else if (phoneNumber.length == 9) {
            res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
          } else if (phoneNumber.length == 10) {
            res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 3) + '-' + phoneNumber.substr(6);
          } else if (phoneNumber.length == 11) {
            //010-1234-5678
            res = phoneNumber.substr(0, 3) + '-' + phoneNumber.substr(3, 4) + '-' + phoneNumber.substr(7);
          } 
        } else if(phoneNumber.indexOf(")")){
          // if (phoneNumber.indexOf(')') > 0) {
          //   res = phoneNumber.substr(0, phoneNumber.indexOf(')'))+phoneNumber.substr(phoneNumber.indexOf(')'));
          // } else {
            //res = phoneNumber.substr(0, phoneNumber.indexOf(")"))
            res = phoneNumber
          //}
        }

      }
      //console.log('res:' + res);
      return res;
    },
    async getTabList(medicalCode) {
      this.tab_options = [];
      this.viewDetailList = [];
      this.viewManagerList = [];
      //   this.scheduleSelectTime = '';
      this.scheduleMemoCs = '';
      this.dcCs = false;
      this.dcStringCs = '';
      this.medicalManagers = '';
      this.medicalDetails = '';
      this.selectedMedicalCodeCs = '';

      this.detailList = [];
      this.managerList = [];

      const jsonData = {
        medicalCode: '02',
      };
      const { data } = await axiosClass.get('/api/patientCalendar/listScheduleTab/', jsonData, true);

      //console.log(data);

      for (let i = 0; i < data.tab_option.length; i++) {
        this.tab_options.push({
          id: data.tab_option[i].MEDICAL_CD,
          label: data.tab_option[i].MEDICAL_NM,
          tabCode: data.tab_option[i].TAB_CODE,
        })
      }

      this.detailList = data.detailList;
      this.managerList = data.managerList;
    },

    selectMedicalDetail() {
      //console.log(this.selectedMedicalCodeCs.id);
      this.viewDetailList = [];
      for (let i = 0; i < this.detailList.length; i++) {
        if (this.detailList[i].MEDICAL_CD == this.selectedMedicalCodeCs.id) {
          this.viewDetailList.push(this.detailList[i]);
        }
      }

      this.viewManagerList = [];
      for (let i = 0; i < this.managerList.length; i++) {
        if (this.managerList[i].MEDICAL_CD == this.selectedMedicalCodeCs.id) {
          this.viewManagerList.push(this.managerList[i]);
        }
      }
      //console.log(this.viewManagerList);
      this.medicalDetails = [];
      this.medicalManagers = [];
      // console.log('this.detailValue:::', this.medicalDetails);
    },
    customFormatter(date) {
      return moment(date).format('YYYY-MM-DD');
    },
    gubunChange() {
      if (this.select_gubun == '') {
        this.memo = '';
        this.select_user = '';
      } else if (this.select_gubun == '1' || this.select_gubun == '2') {
        this.memo = '';
      } else if (this.select_gubun == '99') {
        this.select_user = '';
      }

      if (this.select_gubun != '97') {
        this.autoCheck = null;
        this.schdule_endYN = 'N';
        this.schedule_end = '';
        this.schedule_week = [];
        this.schedule_gubun_type = 0;
        this.schedule_gubun_number = 1;
        this.schedule_gubun_days = 0;
      }
    },
    // 20230427 TH 추가
    // 카카오워크 봇에 메세지 보내는 로직
    async sendKakaoWorkBot() {
      console.log('[KakaoWork Debug] sendKakaoWorkBot 메서드 시작');
      console.log('[KakaoWork Debug] csDatas 정보:', this.csDatas[0]);
      console.log('[KakaoWork Debug] csAddYN 값:', this.csAddYN);

      let csCate = '';

      if (this.csDatas[0].CS_CATE_CODE == 1) {
        csCate = '신규';
      } else if (this.csDatas[0].CS_CATE_CODE == 2) {
        csCate = '신규(재)';
      } else if (this.csDatas[0].CS_CATE_CODE == 3) {
        csCate = '신규(부안과)';
      } else if (this.csDatas[0].CS_CATE_CODE == 4) {
        csCate = '재입원';
      } else if (this.csDatas[0].CS_CATE_CODE == 5) {
        csCate = '입원환자 기타';
      } else if (this.csDatas[0].CS_CATE_CODE == 6) {
        csCate = '외래';
      } else if (this.csDatas[0].CS_CATE_CODE == 7) {
        csCate = '리콜';
      } else if (this.csDatas[0].CS_CATE_CODE == 8) {
        csCate = '기타';
      } else if (this.csDatas[0].CS_CATE_CODE == 9) {
        csCate = '방문상담';
      } else if (this.csDatas[0].CS_CATE_CODE == 10) {
        csCate = '초진';
      } else if (this.csDatas[0].CS_CATE_CODE == 11) {
        csCate = '신입진료';
      } else if (this.csDatas[0].CS_CATE_CODE == 12) {
        csCate = '전화진료';
      }

      let msgText = '';

      if (this.csAddYN == 'Y') {
        msgText = this.patientUsername + '님의 ' + csCate  + ' 문의가 리콜Todo에 추가되었습니다.';
      } else if (this.csAddYN == 'N') {
        msgText = this.patientUsername + '님의 ' + csCate  + ' 문의가 변경되었습니다.';
      }

      //return null;
      let jsonData = {
        conversationId : 6171338, // 대표원장님, 행정원장님, 상담팀, 전산주임이 초대된 리콜알림방의 id
        //conversationId : 6143632, // 개발주임만 있는 방 id for test(리콜알림기능)
        msgText : msgText,
        fromWhere : 1, // 리콜일때 1
        memberEmail : store.getters.getMemberEmail,
        memberName : store.getters.getUSERNAME,
      }

      console.log('[KakaoWork Debug] 카카오워크 API 호출 전송 데이터:', jsonData);

      try {
        const response = await axiosClass.post('/api/kakaoWork/sendMessages', jsonData, true);
        console.log('[KakaoWork Debug] 카카오워크 API 응답:', response);

        if (response && response.data && response.data.success) {
          this.$vs.notify({
            color: 'success',
            title: 'sucess',
            text: "정상적으로 저장되었습니다.",
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-check',
          });
        }
      } catch (error) {
        console.error('[sendKakaoWorkMessage] 카카오워크 메시지 전송 실패:', error);
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: '카카오워크 메시지 전송 중 오류가 발생했습니다. 페이지를 새로고침하고 다시 시도해주세요.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
      } 

    },
    checkInDate () {
      if (this.inDate == null || this.inDate == '') {
        let err_msg = '';
        err_msg = '입원예정일이 입력되지 않았습니다\n그대로 저장하시겠습까?';
        if (err_msg != '') {
          this.$vs.dialog({
            type: 'confirm',
            color: 'green',
            title: '확인',
            text: err_msg,
            position: 'center',
            acceptText: '네',
            cancelText: '취소',
            cancel: function() {
              return;
            }
          });
        }
      }
    },
    changeEtcSchedule () {
      this.etcSchedule = !this.etcSchedule;
    },
    async updateOxygenPoint (divergence) {
      var inputOxygenPoint = this.adjustedOxygenPoint.replace(/[^0-9-]/g, "");

      if (isNaN(inputOxygenPoint) == true) {
        this.$vs.notify({
          title: 'Error',
          text: '유효한 숫자를 입력해주세요',
          color: 'danger',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
          return false;
      }

      try {
        inputOxygenPoint= inputOxygenPoint*divergence
        this.oxygenPoint = Math.round(this.oxygenPoint) + Math.round(inputOxygenPoint);

        const {data} = await axiosClass.post('/api/patient/updateOxygenPoint'
        , {
            patientId : this.patientUid,
            pointValue: inputOxygenPoint,
            pointDetail : '수동적립',
            regId : this.userUid,
          }
        , true);
        console.log(data)
        if (!data.success) {
          this.$vs.notify({
            color: 'danger',
            title: 'Error',
            text: data.message || '산소포인트 업데이트 중 오류가 발생했습니다.',
            position: 'top-right',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
          });
          return;
        }
        this.oxygenPoint = data.pointValue;
        this.$vs.notify({
          color: 'success',
          title: 'success',
          text: "산소포인트 적용이 완료되었습니다.",
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-check',
        });
      } catch (error) {
        console.error('산소포인트 업데이트 에러:', error);
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: '산소포인트 업데이트 중 오류가 발생했습니다. 화면으로 산소포인트 문자를 직접 발송해주세요.',
          position: 'top-right',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
        });
      }
    },
    removeEscape (str) {
      const newStr = str.replace(/\\/g, "");
      return newStr;
    },
    getChangedCsDatas(updatedCsDatas = null) {
      // 편집된 데이터가 제공되면 사용, 아니면 현재 데이터 사용
      const dataToCheck = updatedCsDatas || this.csDatas.map((csData, index) => 
        this.getUpdatedCsData(index, csData)
      );

      const newItems = dataToCheck.filter(cs => cs.SEQ === 0);

      const modifiedItems = dataToCheck
        .filter(cs => cs.SEQ !== 0) // Only existing items
        .filter(currentItem => {
          const originalItem = this.originalCsDatas.find(orig => orig.SEQ === currentItem.SEQ);
          if (!originalItem) {
            return true; 
          }
          return JSON.stringify(currentItem) !== JSON.stringify(originalItem);
        });

      return [...newItems, ...modifiedItems];
    },
    // 상담내역 필터링 및 표시 관련 메서드
    initializeDisplayedData() {
      // 전체 데이터에서 처음 10개만 표시
      this.displayedCsDatas = this.csDatas.slice(0, this.csLoadCount);
    },
    loadMoreCsDatas() {
      if (this.isLoadingMore || !this.hasMoreCsData) return;
      
      this.isLoadingMore = true;
      
      // 비동기 로딩 시뮬레이션
      setTimeout(() => {
        const currentLength = this.displayedCsDatas.length;
        const nextBatch = this.csDatas.slice(
          currentLength,
          currentLength + this.csLoadCount
        );
        
        this.displayedCsDatas.push(...nextBatch);
        this.isLoadingMore = false;
      }, 300);
    },
    handleCsScroll(event) {
      const container = event.target;
      const scrollPosition = container.scrollTop + container.clientHeight;
      const scrollHeight = container.scrollHeight;
      
      // 스크롤이 바닥에서 100px 이내에 도달하면 추가 로드
      if (scrollHeight - scrollPosition < 100 && this.hasMoreCsData && !this.isLoadingMore) {
        this.loadMoreCsDatas();
      }
    },
  },
  mounted() {
    this.now_date = moment().format("YYYY-MM-DD");
    EventBus.$on('memberCs', async uid => {
      this.$vs.loading();
      this.openPopup = false;
      this.uid = uid;
      this.popTabIdx = 2;
      await this.init();
      await this.popTabClick(this.popTabIdx);
      this.csPopup = true;
      setTimeout(() => {
        this.$vs.loading.close();
      }, 1000);
    });
    EventBus.$on('memberView', async uid => {
      this.$vs.loading();
      this.csPopup = false;
      await this.init();
      this.uid = uid;
      await this.memberSelect();
      this.openPopup = true;
      setTimeout(() => {
        this.$vs.loading.close();
      }, 1000);

      // this.$forceUpdate();
    });
  },
};
</script>

<style>
.con-vs-dialog {
  z-index: 500000 !important;
}

.mx-datepicker-popup {
  z-index: 50000000;
}

#memberView .vs-popup {
  width: 1200px !important;
}

#csPopup .vs-popup {
  width: 1200px !important;
}
.activeMenu2 {
  border-bottom-width: 3px !important;
  border-color: #015666 !important;
}
.point-card {
  position: fixed; /* 화면 기준으로 고정 */
  z-index: 1000; /* 다른 요소들 위로 올리기 */
  top: 7%; /* 화면 가운데 위치 */
  left: 50%; /* 화면 가운데 위치 */
  transform: translate(-50%, -50%); /* 완전히 가운데 정렬 */
  width: 300px; /* 카드 너비 조정 */
  background-color: white; /* 배경색 설정 */
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1); /* 그림자 추가 */
  padding: 20px; /* 내부 여백 */
  border-radius: 8px; /* 모서리 둥글게 */
}

/* 상담내역 카드 스크롤 컨테이너 스타일 */
.cs-cards-container {
  max-height: 600px;
  overflow-y: auto;
  padding-right: 10px;
}

/* 스크롤바 스타일링 (선택사항) */
.cs-cards-container::-webkit-scrollbar {
  width: 8px;
}

.cs-cards-container::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.cs-cards-container::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 4px;
}

.cs-cards-container::-webkit-scrollbar-thumb:hover {
  background: #555;
}

/* 로딩 스피너 스타일 */
.vs-spinner {
  margin: 0 auto;
}
</style>
